!function (t, a) {
  "object" == typeof exports && "object" == typeof module ? module.exports = a(require("react"), require("powerbi-client"), require("lodash.isequal")) : "function" == typeof define && define.amd ? define(["react", "powerbi-client", "lodash.isequal"], a) : "object" == typeof exports ? exports["powerbi-client-react"] = a(require("react"), require("powerbi-client"), require("lodash.isequal")) : t["powerbi-client-react"] = a(t.react, t["powerbi-client"], t["lodash.isequal"]);
}(self, function (t, a, e) {
  return function () {
    var r = {
      149: function _(t) {
        var a;
        a = function a() {
          return function () {
            var t = [function (t, a, e) {
              var _r,
                  i = this && this.__extends || (_r = function r(t, a) {
                return _r = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.TextAlignment = a.CommonErrorCodes = a.BookmarksPlayMode = a.ExportDataType = a.QnaMode = a.PageNavigationPosition = a.BrowserPrintAdjustmentsMode = a.AggregateFunction = a.DataCacheMode = a.CredentialType = a.isPercentOfGrandTotal = a.isColumnAggr = a.isHierarchyLevelAggr = a.isHierarchyLevel = a.isColumn = a.isMeasure = a.getFilterType = a.isBasicFilterWithKeys = a.isFilterKeyColumnsTarget = a.HierarchyFilter = a.AdvancedFilter = a.TupleFilter = a.IdentityFilter = a.BasicFilterWithKeys = a.BasicFilter = a.RelativeTimeFilter = a.RelativeDateFilter = a.TopNFilter = a.IncludeExcludeFilter = a.NotSupportedFilter = a.Filter = a.RelativeDateOperators = a.RelativeDateFilterTimeUnit = a.FilterType = a.FiltersLevel = a.FiltersOperations = a.MenuLocation = a.ContrastMode = a.TokenType = a.ViewMode = a.Permissions = a.SectionVisibility = a.ReportAlignment = a.HyperlinkClickBehavior = a.LayoutType = a.VisualContainerDisplayMode = a.BackgroundType = a.DisplayOption = a.PageSizeType = a.TraceType = void 0, a.validateVisualHeader = a.validateExportDataRequest = a.validateQnaInterpretInputData = a.validateLoadQnaConfiguration = a.validateSaveAsParameters = a.validateUpdateFiltersRequest = a.validateFilter = a.validatePage = a.validateTileLoad = a.validateDashboardLoad = a.validateQuickCreate = a.validateCreateReport = a.validatePaginatedReportLoad = a.validateReportLoad = a.validateMenuGroupExtension = a.validateExtension = a.validateCustomPageSize = a.validateVisualizationsPane = a.validateSyncSlicersPane = a.validateSelectionPane = a.validatePageNavigationPane = a.validateFieldsPane = a.validateFiltersPane = a.validateBookmarksPane = a.validatePanes = a.validateSettings = a.validateCaptureBookmarkRequest = a.validateApplyBookmarkStateRequest = a.validateApplyBookmarkByNameRequest = a.validateAddBookmarkRequest = a.validatePlayBookmarkRequest = a.validateSlicerState = a.validateSlicer = a.validateVisualSelector = a.isIExtensionArray = a.isIExtensions = a.isGroupedMenuExtension = a.isFlatMenuExtension = a.isReportFiltersArray = a.isOnLoadFilters = a.VisualDataRoleKindPreference = a.VisualDataRoleKind = a.CommandDisplayOption = a.SlicerTargetSelector = a.VisualTypeSelector = a.VisualSelector = a.PageSelector = a.Selector = a.SortDirection = a.LegendPosition = void 0, a.validatePrintSettings = a.validateZoomLevel = a.validateCustomTheme = a.validateCommandsSettings = a.validateVisualSettings = void 0;

              var o,
                  l,
                  n,
                  d,
                  s,
                  u,
                  p,
                  c,
                  f,
                  V,
                  v,
                  y,
                  h,
                  m,
                  g,
                  w,
                  b,
                  O,
                  _,
                  S = e(1);

              (_ = a.TraceType || (a.TraceType = {}))[_.Information = 0] = "Information", _[_.Verbose = 1] = "Verbose", _[_.Warning = 2] = "Warning", _[_.Error = 3] = "Error", _[_.ExpectedError = 4] = "ExpectedError", _[_.UnexpectedError = 5] = "UnexpectedError", _[_.Fatal = 6] = "Fatal", (O = a.PageSizeType || (a.PageSizeType = {}))[O.Widescreen = 0] = "Widescreen", O[O.Standard = 1] = "Standard", O[O.Cortana = 2] = "Cortana", O[O.Letter = 3] = "Letter", O[O.Custom = 4] = "Custom", O[O.Mobile = 5] = "Mobile", (b = a.DisplayOption || (a.DisplayOption = {}))[b.FitToPage = 0] = "FitToPage", b[b.FitToWidth = 1] = "FitToWidth", b[b.ActualSize = 2] = "ActualSize", (w = a.BackgroundType || (a.BackgroundType = {}))[w.Default = 0] = "Default", w[w.Transparent = 1] = "Transparent", (g = a.VisualContainerDisplayMode || (a.VisualContainerDisplayMode = {}))[g.Visible = 0] = "Visible", g[g.Hidden = 1] = "Hidden", (m = a.LayoutType || (a.LayoutType = {}))[m.Master = 0] = "Master", m[m.Custom = 1] = "Custom", m[m.MobilePortrait = 2] = "MobilePortrait", m[m.MobileLandscape = 3] = "MobileLandscape", (h = a.HyperlinkClickBehavior || (a.HyperlinkClickBehavior = {}))[h.Navigate = 0] = "Navigate", h[h.NavigateAndRaiseEvent = 1] = "NavigateAndRaiseEvent", h[h.RaiseEvent = 2] = "RaiseEvent", (y = a.ReportAlignment || (a.ReportAlignment = {}))[y.Left = 0] = "Left", y[y.Center = 1] = "Center", y[y.Right = 2] = "Right", y[y.None = 3] = "None", (v = a.SectionVisibility || (a.SectionVisibility = {}))[v.AlwaysVisible = 0] = "AlwaysVisible", v[v.HiddenInViewMode = 1] = "HiddenInViewMode", (V = a.Permissions || (a.Permissions = {}))[V.Read = 0] = "Read", V[V.ReadWrite = 1] = "ReadWrite", V[V.Copy = 2] = "Copy", V[V.Create = 4] = "Create", V[V.All = 7] = "All", (f = a.ViewMode || (a.ViewMode = {}))[f.View = 0] = "View", f[f.Edit = 1] = "Edit", (c = a.TokenType || (a.TokenType = {}))[c.Aad = 0] = "Aad", c[c.Embed = 1] = "Embed", (p = a.ContrastMode || (a.ContrastMode = {}))[p.None = 0] = "None", p[p.HighContrast1 = 1] = "HighContrast1", p[p.HighContrast2 = 2] = "HighContrast2", p[p.HighContrastBlack = 3] = "HighContrastBlack", p[p.HighContrastWhite = 4] = "HighContrastWhite", (u = a.MenuLocation || (a.MenuLocation = {}))[u.Bottom = 0] = "Bottom", u[u.Top = 1] = "Top", (s = a.FiltersOperations || (a.FiltersOperations = {}))[s.RemoveAll = 0] = "RemoveAll", s[s.ReplaceAll = 1] = "ReplaceAll", s[s.Add = 2] = "Add", s[s.Replace = 3] = "Replace", (d = a.FiltersLevel || (a.FiltersLevel = {}))[d.Report = 0] = "Report", d[d.Page = 1] = "Page", d[d.Visual = 2] = "Visual", function (t) {
                t[t.Advanced = 0] = "Advanced", t[t.Basic = 1] = "Basic", t[t.Unknown = 2] = "Unknown", t[t.IncludeExclude = 3] = "IncludeExclude", t[t.RelativeDate = 4] = "RelativeDate", t[t.TopN = 5] = "TopN", t[t.Tuple = 6] = "Tuple", t[t.RelativeTime = 7] = "RelativeTime", t[t.Identity = 8] = "Identity", t[t.Hierarchy = 9] = "Hierarchy";
              }(o = a.FilterType || (a.FilterType = {})), (n = a.RelativeDateFilterTimeUnit || (a.RelativeDateFilterTimeUnit = {}))[n.Days = 0] = "Days", n[n.Weeks = 1] = "Weeks", n[n.CalendarWeeks = 2] = "CalendarWeeks", n[n.Months = 3] = "Months", n[n.CalendarMonths = 4] = "CalendarMonths", n[n.Years = 5] = "Years", n[n.CalendarYears = 6] = "CalendarYears", n[n.Minutes = 7] = "Minutes", n[n.Hours = 8] = "Hours", (l = a.RelativeDateOperators || (a.RelativeDateOperators = {}))[l.InLast = 0] = "InLast", l[l.InThis = 1] = "InThis", l[l.InNext = 2] = "InNext";

              var F = function () {
                function t(t, a) {
                  this.target = t, this.filterType = a;
                }

                return t.prototype.toJSON = function () {
                  var t = {
                    $schema: this.schemaUrl,
                    target: this.target,
                    filterType: this.filterType
                  };
                  return void 0 !== this.displaySettings && (t.displaySettings = this.displaySettings), t;
                }, t;
              }();

              a.Filter = F;

              var T = function (t) {
                function a(e, r, i) {
                  var l = t.call(this, e, o.Unknown) || this;
                  return l.message = r, l.notSupportedTypeName = i, l.schemaUrl = a.schemaUrl, l;
                }

                return i(a, t), a.prototype.toJSON = function () {
                  var a = t.prototype.toJSON.call(this);
                  return a.message = this.message, a.notSupportedTypeName = this.notSupportedTypeName, a;
                }, a.schemaUrl = "http://powerbi.com/product/schema#notSupported", a;
              }(F);

              a.NotSupportedFilter = T;

              var P = function (t) {
                function a(e, r, i) {
                  var l = t.call(this, e, o.IncludeExclude) || this;
                  return l.values = i, l.isExclude = r, l.schemaUrl = a.schemaUrl, l;
                }

                return i(a, t), a.prototype.toJSON = function () {
                  var a = t.prototype.toJSON.call(this);
                  return a.isExclude = this.isExclude, a.values = this.values, a;
                }, a.schemaUrl = "http://powerbi.com/product/schema#includeExclude", a;
              }(F);

              a.IncludeExcludeFilter = P;

              var C = function (t) {
                function a(e, r, i, l) {
                  var n = t.call(this, e, o.TopN) || this;
                  return n.operator = r, n.itemCount = i, n.schemaUrl = a.schemaUrl, n.orderBy = l, n;
                }

                return i(a, t), a.prototype.toJSON = function () {
                  var a = t.prototype.toJSON.call(this);
                  return a.operator = this.operator, a.itemCount = this.itemCount, a.orderBy = this.orderBy, a;
                }, a.schemaUrl = "http://powerbi.com/product/schema#topN", a;
              }(F);

              a.TopNFilter = C;

              var R = function (t) {
                function a(e, r, i, l, n) {
                  var d = t.call(this, e, o.RelativeDate) || this;
                  return d.operator = r, d.timeUnitsCount = i, d.timeUnitType = l, d.includeToday = n, d.schemaUrl = a.schemaUrl, d;
                }

                return i(a, t), a.prototype.toJSON = function () {
                  var a = t.prototype.toJSON.call(this);
                  return a.operator = this.operator, a.timeUnitsCount = this.timeUnitsCount, a.timeUnitType = this.timeUnitType, a.includeToday = this.includeToday, a;
                }, a.schemaUrl = "http://powerbi.com/product/schema#relativeDate", a;
              }(F);

              a.RelativeDateFilter = R;

              var k = function (t) {
                function a(e, r, i, l) {
                  var n = t.call(this, e, o.RelativeTime) || this;
                  return n.operator = r, n.timeUnitsCount = i, n.timeUnitType = l, n.schemaUrl = a.schemaUrl, n;
                }

                return i(a, t), a.prototype.toJSON = function () {
                  var a = t.prototype.toJSON.call(this);
                  return a.operator = this.operator, a.timeUnitsCount = this.timeUnitsCount, a.timeUnitType = this.timeUnitType, a;
                }, a.schemaUrl = "http://powerbi.com/product/schema#relativeTime", a;
              }(F);

              a.RelativeTimeFilter = k;

              var M = function (t) {
                function a(e, r) {
                  for (var i = [], l = 2; l < arguments.length; l++) {
                    i[l - 2] = arguments[l];
                  }

                  var n = t.call(this, e, o.Basic) || this;
                  if (n.operator = r, n.schemaUrl = a.schemaUrl, 0 === i.length && "All" !== r) throw new Error('values must be a non-empty array unless your operator is "All".');
                  return Array.isArray(i[0]) ? n.values = i[0] : n.values = i, n;
                }

                return i(a, t), a.prototype.toJSON = function () {
                  var a = t.prototype.toJSON.call(this);
                  return a.operator = this.operator, a.values = this.values, a.requireSingleSelection = !!this.requireSingleSelection, a;
                }, a.schemaUrl = "http://powerbi.com/product/schema#basic", a;
              }(F);

              a.BasicFilter = M;

              var A = function (t) {
                function a(a, e, r, i) {
                  var o = t.call(this, a, e, r) || this;
                  o.keyValues = i, o.target = a;
                  var l = a.keys ? a.keys.length : 0;
                  if (l > 0 && !i) throw new Error("You should pass the values to be filtered for each key. You passed: no values and ".concat(l, " keys"));
                  if (0 === l && i && i.length > 0) throw new Error("You passed key values but your target object doesn't contain the keys to be filtered");

                  for (var n = 0, d = o.keyValues; n < d.length; n++) {
                    var s = d[n];

                    if (s) {
                      var u = s.length;
                      if (u !== l) throw new Error("Each tuple of key values should contain a value for each of the keys. You passed: ".concat(u, " values and ").concat(l, " keys"));
                    }
                  }

                  return o;
                }

                return i(a, t), a.prototype.toJSON = function () {
                  var a = t.prototype.toJSON.call(this);
                  return a.keyValues = this.keyValues, a;
                }, a;
              }(M);

              a.BasicFilterWithKeys = A;

              var j = function (t) {
                function a(e, r) {
                  var i = t.call(this, e, o.Identity) || this;
                  return i.operator = r, i.schemaUrl = a.schemaUrl, i;
                }

                return i(a, t), a.prototype.toJSON = function () {
                  var a = t.prototype.toJSON.call(this);
                  return a.operator = this.operator, a.target = this.target, a;
                }, a.schemaUrl = "http://powerbi.com/product/schema#identity", a;
              }(F);

              a.IdentityFilter = j;

              var E = function (t) {
                function a(e, r, i) {
                  var l = t.call(this, e, o.Tuple) || this;
                  return l.operator = r, l.schemaUrl = a.schemaUrl, l.values = i, l;
                }

                return i(a, t), a.prototype.toJSON = function () {
                  var a = t.prototype.toJSON.call(this);
                  return a.operator = this.operator, a.values = this.values, a.target = this.target, a;
                }, a.schemaUrl = "http://powerbi.com/product/schema#tuple", a;
              }(F);

              a.TupleFilter = E;

              var x = function (t) {
                function a(e, r) {
                  for (var i = [], l = 2; l < arguments.length; l++) {
                    i[l - 2] = arguments[l];
                  }

                  var n,
                      d = t.call(this, e, o.Advanced) || this;
                  if (d.schemaUrl = a.schemaUrl, "string" != typeof r || 0 === r.length) throw new Error("logicalOperator must be a valid operator, You passed: ".concat(r));
                  if (d.logicalOperator = r, (n = Array.isArray(i[0]) ? i[0] : i).length > 2) throw new Error("AdvancedFilters may not have more than two conditions. You passed: ".concat(i.length));
                  if (1 === n.length && "And" !== r) throw new Error('Logical Operator must be "And" when there is only one condition provided');
                  return d.conditions = n, d;
                }

                return i(a, t), a.prototype.toJSON = function () {
                  var a = t.prototype.toJSON.call(this);
                  return a.logicalOperator = this.logicalOperator, a.conditions = this.conditions, a;
                }, a.schemaUrl = "http://powerbi.com/product/schema#advanced", a;
              }(F);

              a.AdvancedFilter = x;

              var q,
                  B,
                  D,
                  N,
                  L,
                  U,
                  H,
                  I,
                  z,
                  J = function (t) {
                function a(e, r) {
                  var i = t.call(this, e, o.Hierarchy) || this;
                  return i.schemaUrl = a.schemaUrl, i.hierarchyData = r, i;
                }

                return i(a, t), a.prototype.toJSON = function () {
                  var a = t.prototype.toJSON.call(this);
                  return a.hierarchyData = this.hierarchyData, a.target = this.target, a;
                }, a.schemaUrl = "http://powerbi.com/product/schema#hierarchy", a;
              }(F);

              function Q(t) {
                if (t.filterType) return t.filterType;
                var a = t,
                    e = t;
                return "string" == typeof a.operator && Array.isArray(a.values) ? o.Basic : "string" == typeof e.logicalOperator && Array.isArray(e.conditions) ? o.Advanced : o.Unknown;
              }

              function G(t) {
                return !(!t.table || !t.column || t.aggregationFunction);
              }

              a.HierarchyFilter = J, a.isFilterKeyColumnsTarget = function (t) {
                return G(t) && !!t.keys;
              }, a.isBasicFilterWithKeys = function (t) {
                return Q(t) === o.Basic && !!t.keyValues;
              }, a.getFilterType = Q, a.isMeasure = function (t) {
                return void 0 !== t.table && void 0 !== t.measure;
              }, a.isColumn = G, a.isHierarchyLevel = function (t) {
                return !(!(t.table && t.hierarchy && t.hierarchyLevel) || t.aggregationFunction);
              }, a.isHierarchyLevelAggr = function (t) {
                return !!(t.table && t.hierarchy && t.hierarchyLevel && t.aggregationFunction);
              }, a.isColumnAggr = function (t) {
                return !!(t.table && t.column && t.aggregationFunction);
              }, a.isPercentOfGrandTotal = function (t) {
                return !!t.percentOfGrandTotal;
              }, (z = a.CredentialType || (a.CredentialType = {}))[z.NoConnection = 0] = "NoConnection", z[z.OnBehalfOf = 1] = "OnBehalfOf", z[z.Anonymous = 2] = "Anonymous", (I = a.DataCacheMode || (a.DataCacheMode = {}))[I.Import = 0] = "Import", I[I.DirectQuery = 1] = "DirectQuery", (H = a.AggregateFunction || (a.AggregateFunction = {}))[H.Default = 1] = "Default", H[H.None = 2] = "None", H[H.Sum = 3] = "Sum", H[H.Min = 4] = "Min", H[H.Max = 5] = "Max", H[H.Count = 6] = "Count", H[H.Average = 7] = "Average", H[H.DistinctCount = 8] = "DistinctCount", (U = a.BrowserPrintAdjustmentsMode || (a.BrowserPrintAdjustmentsMode = {}))[U.Default = 0] = "Default", U[U.NoAdjustments = 1] = "NoAdjustments", (L = a.PageNavigationPosition || (a.PageNavigationPosition = {}))[L.Bottom = 0] = "Bottom", L[L.Left = 1] = "Left", (N = a.QnaMode || (a.QnaMode = {}))[N.Interactive = 0] = "Interactive", N[N.ResultOnly = 1] = "ResultOnly", (D = a.ExportDataType || (a.ExportDataType = {}))[D.Summarized = 0] = "Summarized", D[D.Underlying = 1] = "Underlying", (B = a.BookmarksPlayMode || (a.BookmarksPlayMode = {}))[B.Off = 0] = "Off", B[B.Presentation = 1] = "Presentation", a.CommonErrorCodes = {
                TokenExpired: "TokenExpired",
                NotFound: "PowerBIEntityNotFound",
                InvalidParameters: "Invalid parameters",
                LoadReportFailed: "LoadReportFailed",
                NotAuthorized: "PowerBINotAuthorizedException",
                FailedToLoadModel: "ExplorationContainer_FailedToLoadModel_DefaultDetails"
              }, a.TextAlignment = {
                Left: "left",
                Center: "center",
                Right: "right"
              }, a.LegendPosition = {
                Top: "Top",
                Bottom: "Bottom",
                Right: "Right",
                Left: "Left",
                TopCenter: "TopCenter",
                BottomCenter: "BottomCenter",
                RightCenter: "RightCenter",
                LeftCenter: "LeftCenter"
              }, (q = a.SortDirection || (a.SortDirection = {}))[q.Ascending = 1] = "Ascending", q[q.Descending = 2] = "Descending";

              var W = function () {
                function t(t) {
                  this.$schema = t;
                }

                return t.prototype.toJSON = function () {
                  return {
                    $schema: this.$schema
                  };
                }, t;
              }();

              a.Selector = W;

              var K = function (t) {
                function a(e) {
                  var r = t.call(this, a.schemaUrl) || this;
                  return r.pageName = e, r;
                }

                return i(a, t), a.prototype.toJSON = function () {
                  var a = t.prototype.toJSON.call(this);
                  return a.pageName = this.pageName, a;
                }, a.schemaUrl = "http://powerbi.com/product/schema#pageSelector", a;
              }(W);

              a.PageSelector = K;

              var Y = function (t) {
                function a(e) {
                  var r = t.call(this, a.schemaUrl) || this;
                  return r.visualName = e, r;
                }

                return i(a, t), a.prototype.toJSON = function () {
                  var a = t.prototype.toJSON.call(this);
                  return a.visualName = this.visualName, a;
                }, a.schemaUrl = "http://powerbi.com/product/schema#visualSelector", a;
              }(W);

              a.VisualSelector = Y;

              var $ = function (t) {
                function a(a) {
                  var e = t.call(this, Y.schemaUrl) || this;
                  return e.visualType = a, e;
                }

                return i(a, t), a.prototype.toJSON = function () {
                  var a = t.prototype.toJSON.call(this);
                  return a.visualType = this.visualType, a;
                }, a.schemaUrl = "http://powerbi.com/product/schema#visualTypeSelector", a;
              }(W);

              a.VisualTypeSelector = $;

              var Z,
                  X,
                  tt,
                  at = function (t) {
                function a(a) {
                  var e = t.call(this, Y.schemaUrl) || this;
                  return e.target = a, e;
                }

                return i(a, t), a.prototype.toJSON = function () {
                  var a = t.prototype.toJSON.call(this);
                  return a.target = this.target, a;
                }, a.schemaUrl = "http://powerbi.com/product/schema#slicerTargetSelector", a;
              }(W);

              function et(t) {
                return Array.isArray(t);
              }

              function rt(t) {
                return t && !!t.groupName;
              }

              function it(t) {
                return Array.isArray(t);
              }

              function ot(t) {
                var a = t.message;
                return a || (a = "".concat(t.path, " is invalid. Not meeting ").concat(t.keyword, " constraint")), {
                  message: a
                };
              }

              a.SlicerTargetSelector = at, (tt = a.CommandDisplayOption || (a.CommandDisplayOption = {}))[tt.Enabled = 0] = "Enabled", tt[tt.Disabled = 1] = "Disabled", tt[tt.Hidden = 2] = "Hidden", (X = a.VisualDataRoleKind || (a.VisualDataRoleKind = {}))[X.Grouping = 0] = "Grouping", X[X.Measure = 1] = "Measure", X[X.GroupingOrMeasure = 2] = "GroupingOrMeasure", (Z = a.VisualDataRoleKindPreference || (a.VisualDataRoleKindPreference = {}))[Z.Measure = 0] = "Measure", Z[Z.Grouping = 1] = "Grouping", a.isOnLoadFilters = function (t) {
                return t && !et(t);
              }, a.isReportFiltersArray = et, a.isFlatMenuExtension = function (t) {
                return t && !rt(t);
              }, a.isGroupedMenuExtension = rt, a.isIExtensions = function (t) {
                return t && !it(t);
              }, a.isIExtensionArray = it, a.validateVisualSelector = function (t) {
                var a = S.Validators.visualSelectorValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateSlicer = function (t) {
                var a = S.Validators.slicerValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateSlicerState = function (t) {
                var a = S.Validators.slicerStateValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validatePlayBookmarkRequest = function (t) {
                var a = S.Validators.playBookmarkRequestValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateAddBookmarkRequest = function (t) {
                var a = S.Validators.addBookmarkRequestValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateApplyBookmarkByNameRequest = function (t) {
                var a = S.Validators.applyBookmarkByNameRequestValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateApplyBookmarkStateRequest = function (t) {
                var a = S.Validators.applyBookmarkStateRequestValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateCaptureBookmarkRequest = function (t) {
                var a = S.Validators.captureBookmarkRequestValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateSettings = function (t) {
                var a = S.Validators.settingsValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validatePanes = function (t) {
                var a = S.Validators.reportPanesValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateBookmarksPane = function (t) {
                var a = S.Validators.bookmarksPaneValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateFiltersPane = function (t) {
                var a = S.Validators.filtersPaneValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateFieldsPane = function (t) {
                var a = S.Validators.fieldsPaneValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validatePageNavigationPane = function (t) {
                var a = S.Validators.pageNavigationPaneValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateSelectionPane = function (t) {
                var a = S.Validators.selectionPaneValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateSyncSlicersPane = function (t) {
                var a = S.Validators.syncSlicersPaneValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateVisualizationsPane = function (t) {
                var a = S.Validators.visualizationsPaneValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateCustomPageSize = function (t) {
                var a = S.Validators.customPageSizeValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateExtension = function (t) {
                var a = S.Validators.extensionValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateMenuGroupExtension = function (t) {
                var a = S.Validators.menuGroupExtensionValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateReportLoad = function (t) {
                var a = S.Validators.reportLoadValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validatePaginatedReportLoad = function (t) {
                var a = S.Validators.paginatedReportLoadValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateCreateReport = function (t) {
                var a = S.Validators.reportCreateValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateQuickCreate = function (t) {
                var a = S.Validators.quickCreateValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateDashboardLoad = function (t) {
                var a = S.Validators.dashboardLoadValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateTileLoad = function (t) {
                var a = S.Validators.tileLoadValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validatePage = function (t) {
                var a = S.Validators.pageValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateFilter = function (t) {
                var a = S.Validators.filterValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateUpdateFiltersRequest = function (t) {
                var a = S.Validators.updateFiltersRequestValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateSaveAsParameters = function (t) {
                var a = S.Validators.saveAsParametersValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateLoadQnaConfiguration = function (t) {
                var a = S.Validators.loadQnaValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateQnaInterpretInputData = function (t) {
                var a = S.Validators.qnaInterpretInputDataValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateExportDataRequest = function (t) {
                var a = S.Validators.exportDataRequestValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateVisualHeader = function (t) {
                var a = S.Validators.visualHeaderValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateVisualSettings = function (t) {
                var a = S.Validators.visualSettingsValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateCommandsSettings = function (t) {
                var a = S.Validators.commandsSettingsValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateCustomTheme = function (t) {
                var a = S.Validators.customThemeValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validateZoomLevel = function (t) {
                var a = S.Validators.zoomLevelValidator.validate(t);
                return a ? a.map(ot) : void 0;
              }, a.validatePrintSettings = function (t) {
                var a = S.Validators.printSettingsValidator.validate(t);
                return a ? a.map(ot) : void 0;
              };
            }, function (t, a, e) {
              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.Validators = void 0;

              var r = e(2),
                  i = e(5),
                  o = e(6),
                  l = e(7),
                  n = e(8),
                  d = e(9),
                  s = e(10),
                  u = e(11),
                  p = e(12),
                  c = e(13),
                  f = e(14),
                  V = e(15),
                  v = e(16),
                  y = e(17),
                  h = e(18),
                  m = e(19),
                  g = e(20),
                  w = e(21),
                  b = e(22),
                  O = e(23),
                  _ = e(24),
                  S = e(25),
                  F = e(26),
                  T = e(27),
                  P = e(28),
                  C = e(29),
                  R = e(4),
                  k = e(30),
                  M = e(31),
                  A = e(32),
                  j = e(33);

              a.Validators = {
                addBookmarkRequestValidator: new i.AddBookmarkRequestValidator(),
                advancedFilterTypeValidator: new R.EnumValidator([0]),
                advancedFilterValidator: new p.AdvancedFilterValidator(),
                anyArrayValidator: new R.ArrayValidator([new F.AnyOfValidator([new R.StringValidator(), new R.NumberValidator(), new R.BooleanValidator()])]),
                anyFilterValidator: new F.AnyOfValidator([new p.BasicFilterValidator(), new p.AdvancedFilterValidator(), new p.IncludeExcludeFilterValidator(), new p.NotSupportedFilterValidator(), new p.RelativeDateFilterValidator(), new p.TopNFilterValidator(), new p.RelativeTimeFilterValidator(), new p.HierarchyFilterValidator()]),
                anyValueValidator: new F.AnyOfValidator([new R.StringValidator(), new R.NumberValidator(), new R.BooleanValidator()]),
                actionBarValidator: new r.ActionBarValidator(),
                statusBarValidator: new r.StatusBarValidator(),
                applyBookmarkByNameRequestValidator: new i.ApplyBookmarkByNameRequestValidator(),
                applyBookmarkStateRequestValidator: new i.ApplyBookmarkStateRequestValidator(),
                applyBookmarkValidator: new F.AnyOfValidator([new i.ApplyBookmarkByNameRequestValidator(), new i.ApplyBookmarkStateRequestValidator()]),
                backgroundValidator: new R.EnumValidator([0, 1]),
                basicFilterTypeValidator: new R.EnumValidator([1]),
                basicFilterValidator: new p.BasicFilterValidator(),
                booleanArrayValidator: new R.BooleanArrayValidator(),
                booleanValidator: new R.BooleanValidator(),
                bookmarksPaneValidator: new V.BookmarksPaneValidator(),
                captureBookmarkOptionsValidator: new i.CaptureBookmarkOptionsValidator(),
                captureBookmarkRequestValidator: new i.CaptureBookmarkRequestValidator(),
                columnSchemaArrayValidator: new R.ArrayValidator([new M.ColumnSchemaValidator()]),
                commandDisplayOptionValidator: new R.EnumValidator([0, 1, 2]),
                commandExtensionSelectorValidator: new F.AnyOfValidator([new w.VisualSelectorValidator(), new w.VisualTypeSelectorValidator()]),
                commandExtensionArrayValidator: new R.ArrayValidator([new u.CommandExtensionValidator()]),
                commandExtensionValidator: new u.CommandExtensionValidator(),
                commandsSettingsArrayValidator: new R.ArrayValidator([new o.CommandsSettingsValidator()]),
                commandsSettingsValidator: new o.CommandsSettingsValidator(),
                conditionItemValidator: new p.ConditionItemValidator(),
                contrastModeValidator: new R.EnumValidator([0, 1, 2, 3, 4]),
                credentialDetailsValidator: new C.MapValidator([new R.StringValidator()], [new R.StringValidator()]),
                credentialsValidator: new M.CredentialsValidator(),
                credentialTypeValidator: new R.EnumValidator([0, 1, 2]),
                customLayoutDisplayOptionValidator: new R.EnumValidator([0, 1, 2]),
                customLayoutValidator: new c.CustomLayoutValidator(),
                customPageSizeValidator: new f.CustomPageSizeValidator(),
                customThemeValidator: new l.CustomThemeValidator(),
                dashboardLoadValidator: new n.DashboardLoadValidator(),
                dataCacheModeValidator: new R.EnumValidator([0, 1]),
                datasetBindingValidator: new d.DatasetBindingValidator(),
                datasetCreateConfigValidator: new M.DatasetCreateConfigValidator(),
                datasourceConnectionConfigValidator: new M.DatasourceConnectionConfigValidator(),
                displayStateModeValidator: new R.EnumValidator([0, 1]),
                displayStateValidator: new c.DisplayStateValidator(),
                exportDataRequestValidator: new s.ExportDataRequestValidator(),
                extensionArrayValidator: new R.ArrayValidator([new u.ExtensionValidator()]),
                extensionsValidator: new F.AnyOfValidator([new R.ArrayValidator([new u.ExtensionValidator()]), new u.ExtensionsValidator()]),
                extensionPointsValidator: new u.ExtensionPointsValidator(),
                extensionValidator: new u.ExtensionValidator(),
                fieldForbiddenValidator: new T.FieldForbiddenValidator(),
                fieldRequiredValidator: new P.FieldRequiredValidator(),
                fieldsPaneValidator: new V.FieldsPaneValidator(),
                filterColumnTargetValidator: new p.FilterColumnTargetValidator(),
                filterDisplaySettingsValidator: new p.FilterDisplaySettingsValidator(),
                filterConditionsValidator: new R.ArrayValidator([new p.ConditionItemValidator()]),
                filterHierarchyTargetValidator: new p.FilterHierarchyTargetValidator(),
                filterMeasureTargetValidator: new p.FilterMeasureTargetValidator(),
                filterTargetValidator: new F.AnyOfValidator([new p.FilterColumnTargetValidator(), new p.FilterHierarchyTargetValidator(), new p.FilterMeasureTargetValidator(), new R.ArrayValidator([new F.AnyOfValidator([new p.FilterColumnTargetValidator(), new p.FilterHierarchyTargetValidator(), new p.FilterMeasureTargetValidator(), new p.FilterKeyColumnsTargetValidator(), new p.FilterKeyHierarchyTargetValidator()])])]),
                filterValidator: new p.FilterValidator(),
                filterTypeValidator: new R.EnumValidator([0, 1, 2, 3, 4, 5, 6, 7, 9]),
                filtersArrayValidator: new R.ArrayValidator([new p.FilterValidator()]),
                filtersOperationsUpdateValidator: new R.EnumValidator([1, 2, 3]),
                filtersOperationsRemoveAllValidator: new R.EnumValidator([0]),
                filtersPaneValidator: new V.FiltersPaneValidator(),
                hyperlinkClickBehaviorValidator: new R.EnumValidator([0, 1, 2]),
                includeExcludeFilterValidator: new p.IncludeExcludeFilterValidator(),
                includeExludeFilterTypeValidator: new R.EnumValidator([3]),
                hierarchyFilterTypeValidator: new R.EnumValidator([9]),
                hierarchyFilterValuesValidator: new R.ArrayValidator([new p.HierarchyFilterNodeValidator()]),
                layoutTypeValidator: new R.EnumValidator([0, 1, 2, 3]),
                loadQnaValidator: new v.LoadQnaValidator(),
                menuExtensionValidator: new F.AnyOfValidator([new u.FlatMenuExtensionValidator(), new u.GroupedMenuExtensionValidator()]),
                menuGroupExtensionArrayValidator: new R.ArrayValidator([new u.MenuGroupExtensionValidator()]),
                menuGroupExtensionValidator: new u.MenuGroupExtensionValidator(),
                menuLocationValidator: new R.EnumValidator([0, 1]),
                notSupportedFilterTypeValidator: new R.EnumValidator([2]),
                notSupportedFilterValidator: new p.NotSupportedFilterValidator(),
                numberArrayValidator: new R.NumberArrayValidator(),
                numberValidator: new R.NumberValidator(),
                onLoadFiltersBaseValidator: new F.AnyOfValidator([new p.OnLoadFiltersBaseValidator(), new p.OnLoadFiltersBaseRemoveOperationValidator()]),
                pageLayoutValidator: new C.MapValidator([new R.StringValidator()], [new c.VisualLayoutValidator()]),
                pageNavigationPaneValidator: new V.PageNavigationPaneValidator(),
                pageNavigationPositionValidator: new R.EnumValidator([0, 1]),
                pageSizeTypeValidator: new R.EnumValidator([0, 1, 2, 3, 4, 5]),
                pageSizeValidator: new f.PageSizeValidator(),
                pageValidator: new f.PageValidator(),
                pageViewFieldValidator: new f.PageViewFieldValidator(),
                pagesLayoutValidator: new C.MapValidator([new R.StringValidator()], [new c.PageLayoutValidator()]),
                paginatedReportCommandsValidator: new o.PaginatedReportCommandsValidator(),
                paginatedReportLoadValidator: new m.PaginatedReportLoadValidator(),
                paginatedReportsettingsValidator: new b.PaginatedReportSettingsValidator(),
                parameterValuesArrayValidator: new R.ArrayValidator([new m.ReportParameterFieldsValidator()]),
                parametersPanelValidator: new k.ParametersPanelValidator(),
                permissionsValidator: new R.EnumValidator([0, 1, 2, 4, 7]),
                playBookmarkRequestValidator: new i.PlayBookmarkRequestValidator(),
                printSettingsValidator: new j.PrintSettingsValidator(),
                qnaInterpretInputDataValidator: new v.QnaInterpretInputDataValidator(),
                qnaPanesValidator: new V.QnaPanesValidator(),
                qnaSettingValidator: new v.QnaSettingsValidator(),
                quickCreateValidator: new A.QuickCreateValidator(),
                rawDataValidator: new R.ArrayValidator([new R.ArrayValidator([new R.StringValidator()])]),
                relativeDateFilterOperatorValidator: new R.EnumValidator([0, 1, 2]),
                relativeDateFilterTimeUnitTypeValidator: new R.EnumValidator([0, 1, 2, 3, 4, 5, 6]),
                relativeDateFilterTypeValidator: new R.EnumValidator([4]),
                relativeDateFilterValidator: new p.RelativeDateFilterValidator(),
                relativeDateTimeFilterTypeValidator: new R.EnumValidator([4, 7]),
                relativeDateTimeFilterUnitTypeValidator: new R.EnumValidator([0, 1, 2, 3, 4, 5, 6, 7, 8]),
                relativeTimeFilterTimeUnitTypeValidator: new R.EnumValidator([7, 8]),
                relativeTimeFilterTypeValidator: new R.EnumValidator([7]),
                relativeTimeFilterValidator: new p.RelativeTimeFilterValidator(),
                reportBarsValidator: new r.ReportBarsValidator(),
                reportCreateValidator: new y.ReportCreateValidator(),
                reportLoadFiltersValidator: new F.AnyOfValidator([new R.ArrayValidator([new p.FilterValidator()]), new p.OnLoadFiltersValidator()]),
                reportLoadValidator: new h.ReportLoadValidator(),
                reportPanesValidator: new V.ReportPanesValidator(),
                saveAsParametersValidator: new g.SaveAsParametersValidator(),
                selectionPaneValidator: new V.SelectionPaneValidator(),
                settingsValidator: new b.SettingsValidator(),
                singleCommandSettingsValidator: new o.SingleCommandSettingsValidator(),
                slicerSelectorValidator: new F.AnyOfValidator([new w.VisualSelectorValidator(), new w.SlicerTargetSelectorValidator()]),
                slicerStateValidator: new O.SlicerStateValidator(),
                slicerTargetValidator: new F.AnyOfValidator([new p.FilterColumnTargetValidator(), new p.FilterHierarchyTargetValidator(), new p.FilterMeasureTargetValidator(), new p.FilterKeyColumnsTargetValidator(), new p.FilterKeyHierarchyTargetValidator()]),
                slicerValidator: new O.SlicerValidator(),
                stringArrayValidator: new R.StringArrayValidator(),
                stringValidator: new R.StringValidator(),
                syncSlicersPaneValidator: new V.SyncSlicersPaneValidator(),
                tableDataArrayValidator: new R.ArrayValidator([new M.TableDataValidator()]),
                tableSchemaListValidator: new R.ArrayValidator([new M.TableSchemaValidator()]),
                tileLoadValidator: new _.TileLoadValidator(),
                tokenTypeValidator: new R.EnumValidator([0, 1]),
                topNFilterTypeValidator: new R.EnumValidator([5]),
                topNFilterValidator: new p.TopNFilterValidator(),
                updateFiltersRequestValidator: new F.AnyOfValidator([new p.UpdateFiltersRequestValidator(), new p.RemoveFiltersRequestValidator()]),
                viewModeValidator: new R.EnumValidator([0, 1]),
                visualCommandSelectorValidator: new F.AnyOfValidator([new w.VisualSelectorValidator(), new w.VisualTypeSelectorValidator()]),
                visualHeaderSelectorValidator: new F.AnyOfValidator([new w.VisualSelectorValidator(), new w.VisualTypeSelectorValidator()]),
                visualHeaderSettingsValidator: new S.VisualHeaderSettingsValidator(),
                visualHeaderValidator: new S.VisualHeaderValidator(),
                visualHeadersValidator: new R.ArrayValidator([new S.VisualHeaderValidator()]),
                visualizationsPaneValidator: new V.VisualizationsPaneValidator(),
                visualLayoutValidator: new c.VisualLayoutValidator(),
                visualSelectorValidator: new w.VisualSelectorValidator(),
                visualSettingsValidator: new S.VisualSettingsValidator(),
                visualTypeSelectorValidator: new w.VisualTypeSelectorValidator(),
                zoomLevelValidator: new R.RangeValidator(.25, 4)
              };
            }, function (t, a, e) {
              var _r2,
                  i = this && this.__extends || (_r2 = function r(t, a) {
                return _r2 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r2(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r2(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.StatusBarValidator = a.ActionBarValidator = a.ReportBarsValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "actionBar",
                    validators: [n.Validators.actionBarValidator]
                  }, {
                    field: "statusBar",
                    validators: [n.Validators.statusBarValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.ReportBarsValidator = d;

              var s = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "visible",
                    validators: [n.Validators.booleanValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.ActionBarValidator = s;

              var u = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "visible",
                    validators: [n.Validators.booleanValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.StatusBarValidator = u;
            }, function (t, a) {
              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.MultipleFieldsValidator = void 0;

              var e = function () {
                function t(t) {
                  this.fieldValidatorsPairs = t;
                }

                return t.prototype.validate = function (t, a, e) {
                  if (!this.fieldValidatorsPairs) return null;

                  for (var r = a ? a + "." + e : e, i = 0, o = this.fieldValidatorsPairs; i < o.length; i++) {
                    for (var l = o[i], n = 0, d = l.validators; n < d.length; n++) {
                      var s = d[n].validate(t[l.field], r, l.field);
                      if (s) return s;
                    }
                  }

                  return null;
                }, t;
              }();

              a.MultipleFieldsValidator = e;
            }, function (t, a) {
              var _e,
                  r = this && this.__extends || (_e = function e(t, a) {
                return _e = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _e(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function r() {
                  this.constructor = t;
                }

                _e(t, a), t.prototype = null === a ? Object.create(a) : (r.prototype = a.prototype, new r());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.RangeValidator = a.NumberArrayValidator = a.BooleanArrayValidator = a.StringArrayValidator = a.EnumValidator = a.SchemaValidator = a.ValueValidator = a.NumberValidator = a.BooleanValidator = a.StringValidator = a.TypeValidator = a.ArrayValidator = a.ObjectValidator = void 0;

              var i = function () {
                function t() {}

                return t.prototype.validate = function (t, a, e) {
                  return null == t ? null : "object" != typeof t || Array.isArray(t) ? [{
                    message: void 0 !== e ? e + " must be an object" : "input must be an object",
                    path: a,
                    keyword: "type"
                  }] : null;
                }, t;
              }();

              a.ObjectValidator = i;

              var o = function () {
                function t(t) {
                  this.itemValidators = t;
                }

                return t.prototype.validate = function (t, a, e) {
                  if (null == t) return null;
                  if (!Array.isArray(t)) return [{
                    message: e + " property is invalid",
                    path: (a ? a + "." : "") + e,
                    keyword: "type"
                  }];

                  for (var r = 0; r < t.length; r++) {
                    for (var i = (a ? a + "." : "") + e + "." + r.toString(), o = 0, l = this.itemValidators; o < l.length; o++) {
                      if (l[o].validate(t[r], i, e)) return [{
                        message: e + " property is invalid",
                        path: (a ? a + "." : "") + e,
                        keyword: "type"
                      }];
                    }
                  }

                  return null;
                }, t;
              }();

              a.ArrayValidator = o;

              var l = function () {
                function t(t) {
                  this.expectedType = t;
                }

                return t.prototype.validate = function (t, a, e) {
                  return null == t ? null : typeof t !== this.expectedType ? [{
                    message: e + " must be a " + this.expectedType,
                    path: (a ? a + "." : "") + e,
                    keyword: "type"
                  }] : null;
                }, t;
              }();

              a.TypeValidator = l;

              var n = function (t) {
                function a() {
                  return t.call(this, "string") || this;
                }

                return r(a, t), a;
              }(l);

              a.StringValidator = n;

              var d = function (t) {
                function a() {
                  return t.call(this, "boolean") || this;
                }

                return r(a, t), a;
              }(l);

              a.BooleanValidator = d;

              var s = function (t) {
                function a() {
                  return t.call(this, "number") || this;
                }

                return r(a, t), a;
              }(l);

              a.NumberValidator = s;

              var u = function () {
                function t(t) {
                  this.possibleValues = t;
                }

                return t.prototype.validate = function (t, a, e) {
                  return null == t ? null : this.possibleValues.indexOf(t) < 0 ? [{
                    message: e + " property is invalid",
                    path: (a ? a + "." : "") + e,
                    keyword: "invalid"
                  }] : null;
                }, t;
              }();

              a.ValueValidator = u;

              var p = function (t) {
                function a(a) {
                  var e = t.call(this, [a]) || this;
                  return e.schemaValue = a, e;
                }

                return r(a, t), a.prototype.validate = function (a, e, r) {
                  return t.prototype.validate.call(this, a, e, r);
                }, a;
              }(u);

              a.SchemaValidator = p;

              var c = function (t) {
                function a(a) {
                  var e = t.call(this) || this;
                  return e.possibleValues = a, e;
                }

                return r(a, t), a.prototype.validate = function (a, e, r) {
                  return null == a ? null : t.prototype.validate.call(this, a, e, r) || new u(this.possibleValues).validate(a, e, r);
                }, a;
              }(s);

              a.EnumValidator = c;

              var f = function (t) {
                function a() {
                  return t.call(this, [new n()]) || this;
                }

                return r(a, t), a.prototype.validate = function (a, e, r) {
                  return t.prototype.validate.call(this, a, e, r) ? [{
                    message: r + " must be an array of strings",
                    path: (e ? e + "." : "") + r,
                    keyword: "type"
                  }] : null;
                }, a;
              }(o);

              a.StringArrayValidator = f;

              var V = function (t) {
                function a() {
                  return t.call(this, [new d()]) || this;
                }

                return r(a, t), a.prototype.validate = function (a, e, r) {
                  return t.prototype.validate.call(this, a, e, r) ? [{
                    message: r + " must be an array of booleans",
                    path: (e ? e + "." : "") + r,
                    keyword: "type"
                  }] : null;
                }, a;
              }(o);

              a.BooleanArrayValidator = V;

              var v = function (t) {
                function a() {
                  return t.call(this, [new s()]) || this;
                }

                return r(a, t), a.prototype.validate = function (a, e, r) {
                  return t.prototype.validate.call(this, a, e, r) ? [{
                    message: r + " must be an array of numbers",
                    path: (e ? e + "." : "") + r,
                    keyword: "type"
                  }] : null;
                }, a;
              }(o);

              a.NumberArrayValidator = v;

              var y = function (t) {
                function a(a, e) {
                  var r = t.call(this) || this;
                  return r.minValue = a, r.maxValue = e, r;
                }

                return r(a, t), a.prototype.validate = function (a, e, r) {
                  return null == a ? null : t.prototype.validate.call(this, a, e, r) || (a > this.maxValue || a < this.minValue ? [{
                    message: r + " must be a number between " + this.minValue.toString() + " and " + this.maxValue.toString(),
                    path: (e ? e + "." : "") + r,
                    keyword: "range"
                  }] : null);
                }, a;
              }(s);

              a.RangeValidator = y;
            }, function (t, a, e) {
              var _r3,
                  i = this && this.__extends || (_r3 = function r(t, a) {
                return _r3 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r3(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r3(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.CaptureBookmarkRequestValidator = a.CaptureBookmarkOptionsValidator = a.ApplyBookmarkStateRequestValidator = a.ApplyBookmarkByNameRequestValidator = a.AddBookmarkRequestValidator = a.PlayBookmarkRequestValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var d = [{
                    field: "playMode",
                    validators: [n.Validators.fieldRequiredValidator, new l.EnumValidator([0, 1])]
                  }];
                  return new o.MultipleFieldsValidator(d).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.PlayBookmarkRequestValidator = d;

              var s = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "state",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "displayName",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "apply",
                    validators: [n.Validators.booleanValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.AddBookmarkRequestValidator = s;

              var u = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "name",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.ApplyBookmarkByNameRequestValidator = u;

              var p = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "state",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.ApplyBookmarkStateRequestValidator = p;

              var c = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "personalizeVisuals",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "allPages",
                    validators: [n.Validators.booleanValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.CaptureBookmarkOptionsValidator = c;

              var f = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "options",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.captureBookmarkOptionsValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.CaptureBookmarkRequestValidator = f;
            }, function (t, a, e) {
              var _r4,
                  i = this && this.__extends || (_r4 = function r(t, a) {
                return _r4 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r4(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r4(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.PaginatedReportCommandsValidator = a.SingleCommandSettingsValidator = a.CommandsSettingsValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "copy",
                    validators: [n.Validators.singleCommandSettingsValidator]
                  }, {
                    field: "drill",
                    validators: [n.Validators.singleCommandSettingsValidator]
                  }, {
                    field: "drillthrough",
                    validators: [n.Validators.singleCommandSettingsValidator]
                  }, {
                    field: "expandCollapse",
                    validators: [n.Validators.singleCommandSettingsValidator]
                  }, {
                    field: "exportData",
                    validators: [n.Validators.singleCommandSettingsValidator]
                  }, {
                    field: "includeExclude",
                    validators: [n.Validators.singleCommandSettingsValidator]
                  }, {
                    field: "removeVisual",
                    validators: [n.Validators.singleCommandSettingsValidator]
                  }, {
                    field: "search",
                    validators: [n.Validators.singleCommandSettingsValidator]
                  }, {
                    field: "seeData",
                    validators: [n.Validators.singleCommandSettingsValidator]
                  }, {
                    field: "sort",
                    validators: [n.Validators.singleCommandSettingsValidator]
                  }, {
                    field: "spotlight",
                    validators: [n.Validators.singleCommandSettingsValidator]
                  }, {
                    field: "insightsAnalysis",
                    validators: [n.Validators.singleCommandSettingsValidator]
                  }, {
                    field: "addComment",
                    validators: [n.Validators.singleCommandSettingsValidator]
                  }, {
                    field: "groupVisualContainers",
                    validators: [n.Validators.singleCommandSettingsValidator]
                  }, {
                    field: "summarize",
                    validators: [n.Validators.singleCommandSettingsValidator]
                  }, {
                    field: "clearSelection",
                    validators: [n.Validators.singleCommandSettingsValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.CommandsSettingsValidator = d;

              var s = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "displayOption",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.commandDisplayOptionValidator]
                  }, {
                    field: "selector",
                    validators: [n.Validators.visualCommandSelectorValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.SingleCommandSettingsValidator = s;

              var u = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "parameterPanel",
                    validators: [n.Validators.parametersPanelValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.PaginatedReportCommandsValidator = u;
            }, function (t, a, e) {
              var _r5,
                  i = this && this.__extends || (_r5 = function r(t, a) {
                return _r5 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r5(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r5(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.CustomThemeValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var n = [{
                    field: "themeJson",
                    validators: [new l.ObjectValidator()]
                  }];
                  return new o.MultipleFieldsValidator(n).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.CustomThemeValidator = n;
            }, function (t, a, e) {
              var _r6,
                  i = this && this.__extends || (_r6 = function r(t, a) {
                return _r6 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r6(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r6(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.DashboardLoadValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "accessToken",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "id",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "groupId",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "pageView",
                    validators: [n.Validators.pageViewFieldValidator]
                  }, {
                    field: "tokenType",
                    validators: [n.Validators.tokenTypeValidator]
                  }, {
                    field: "embedUrl",
                    validators: [n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.DashboardLoadValidator = d;
            }, function (t, a, e) {
              var _r7,
                  i = this && this.__extends || (_r7 = function r(t, a) {
                return _r7 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r7(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r7(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.DatasetBindingValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "datasetId",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.DatasetBindingValidator = d;
            }, function (t, a, e) {
              var _r8,
                  i = this && this.__extends || (_r8 = function r(t, a) {
                return _r8 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r8(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r8(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.ExportDataRequestValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var n = [{
                    field: "rows",
                    validators: [new l.NumberValidator()]
                  }, {
                    field: "exportDataType",
                    validators: [new l.EnumValidator([0, 1])]
                  }];
                  return new o.MultipleFieldsValidator(n).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.ExportDataRequestValidator = n;
            }, function (t, a, e) {
              var _r9,
                  i = this && this.__extends || (_r9 = function r(t, a) {
                return _r9 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r9(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r9(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.ExtensionsValidator = a.MenuGroupExtensionValidator = a.ExtensionValidator = a.CommandExtensionValidator = a.ExtensionItemValidator = a.ExtensionPointsValidator = a.GroupedMenuExtensionValidator = a.FlatMenuExtensionValidator = a.MenuExtensionBaseValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "title",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "icon",
                    validators: [n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.MenuExtensionBaseValidator = d;

              var s = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "menuLocation",
                    validators: [n.Validators.menuLocationValidator]
                  }, {
                    field: "groupName",
                    validators: [n.Validators.fieldForbiddenValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(d);

              a.FlatMenuExtensionValidator = s;

              var u = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "groupName",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "menuLocation",
                    validators: [n.Validators.fieldForbiddenValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(d);

              a.GroupedMenuExtensionValidator = u;

              var p = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "visualContextMenu",
                    validators: [n.Validators.menuExtensionValidator]
                  }, {
                    field: "visualOptionsMenu",
                    validators: [n.Validators.menuExtensionValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.ExtensionPointsValidator = p;

              var c = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "name",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "extend",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.extensionPointsValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.ExtensionItemValidator = c;

              var f = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "title",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "icon",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "selector",
                    validators: [n.Validators.commandExtensionSelectorValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(c);

              a.CommandExtensionValidator = f;

              var V = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "command",
                    validators: [n.Validators.commandExtensionValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.ExtensionValidator = V;

              var v = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "name",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "title",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "menuLocation",
                    validators: [n.Validators.menuLocationValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.MenuGroupExtensionValidator = v;

              var y = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "commands",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.commandExtensionArrayValidator]
                  }, {
                    field: "groups",
                    validators: [n.Validators.menuGroupExtensionArrayValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.ExtensionsValidator = y;
            }, function (t, a, e) {
              var _r10,
                  i = this && this.__extends || (_r10 = function r(t, a) {
                return _r10 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r10(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r10(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.OnLoadFiltersValidator = a.OnLoadFiltersBaseRemoveOperationValidator = a.OnLoadFiltersBaseValidator = a.ConditionItemValidator = a.RemoveFiltersRequestValidator = a.UpdateFiltersRequestValidator = a.FilterValidator = a.HierarchyFilterNodeValidator = a.HierarchyFilterValidator = a.IncludeExcludeFilterValidator = a.NotSupportedFilterValidator = a.TopNFilterValidator = a.RelativeTimeFilterValidator = a.RelativeDateFilterValidator = a.RelativeDateTimeFilterValidator = a.AdvancedFilterValidator = a.BasicFilterValidator = a.FilterValidatorBase = a.FilterDisplaySettingsValidator = a.FilterMeasureTargetValidator = a.FilterKeyHierarchyTargetValidator = a.FilterHierarchyTargetValidator = a.FilterKeyColumnsTargetValidator = a.FilterColumnTargetValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "table",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "column",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.FilterColumnTargetValidator = d;

              var s = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "keys",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringArrayValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(d);

              a.FilterKeyColumnsTargetValidator = s;

              var u = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "table",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "hierarchy",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "hierarchyLevel",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.FilterHierarchyTargetValidator = u;

              var p = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "keys",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringArrayValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(u);

              a.FilterKeyHierarchyTargetValidator = p;

              var c = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "table",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "measure",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.FilterMeasureTargetValidator = c;

              var f = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "isLockedInViewMode",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "isHiddenInViewMode",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "displayName",
                    validators: [n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.FilterDisplaySettingsValidator = f;

              var V = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "target",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.filterTargetValidator]
                  }, {
                    field: "$schema",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "filterType",
                    validators: [n.Validators.filterTypeValidator]
                  }, {
                    field: "displaySettings",
                    validators: [n.Validators.filterDisplaySettingsValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.FilterValidatorBase = V;

              var v = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "operator",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "values",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.anyArrayValidator]
                  }, {
                    field: "filterType",
                    validators: [n.Validators.basicFilterTypeValidator]
                  }, {
                    field: "requireSingleSelection",
                    validators: [n.Validators.booleanValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(V);

              a.BasicFilterValidator = v;

              var y = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "logicalOperator",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "conditions",
                    validators: [n.Validators.filterConditionsValidator]
                  }, {
                    field: "filterType",
                    validators: [n.Validators.advancedFilterTypeValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(V);

              a.AdvancedFilterValidator = y;

              var h = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "operator",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.relativeDateFilterOperatorValidator]
                  }, {
                    field: "timeUnitsCount",
                    validators: [n.Validators.numberValidator]
                  }, {
                    field: "timeUnitType",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.relativeDateTimeFilterUnitTypeValidator]
                  }, {
                    field: "filterType",
                    validators: [n.Validators.relativeDateTimeFilterTypeValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(V);

              a.RelativeDateTimeFilterValidator = h;

              var m = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "includeToday",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.booleanValidator]
                  }, {
                    field: "timeUnitType",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.relativeDateFilterTimeUnitTypeValidator]
                  }, {
                    field: "filterType",
                    validators: [n.Validators.relativeDateFilterTypeValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(h);

              a.RelativeDateFilterValidator = m;

              var g = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "timeUnitType",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.relativeTimeFilterTimeUnitTypeValidator]
                  }, {
                    field: "filterType",
                    validators: [n.Validators.relativeTimeFilterTypeValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(h);

              a.RelativeTimeFilterValidator = g;

              var w = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "operator",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "itemCount",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.numberValidator]
                  }, {
                    field: "filterType",
                    validators: [n.Validators.topNFilterTypeValidator]
                  }, {
                    field: "orderBy",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.filterTargetValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(V);

              a.TopNFilterValidator = w;

              var b = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "message",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "notSupportedTypeName",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "filterType",
                    validators: [n.Validators.notSupportedFilterTypeValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(V);

              a.NotSupportedFilterValidator = b;

              var O = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "isExclude",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.booleanValidator]
                  }, {
                    field: "values",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.anyArrayValidator]
                  }, {
                    field: "filterType",
                    validators: [n.Validators.includeExludeFilterTypeValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(V);

              a.IncludeExcludeFilterValidator = O;

              var _ = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "hierarchyData",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.hierarchyFilterValuesValidator]
                  }, {
                    field: "filterType",
                    validators: [n.Validators.hierarchyFilterTypeValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(V);

              a.HierarchyFilterValidator = _;

              var S = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "value",
                    validators: [n.Validators.anyValueValidator]
                  }, {
                    field: "keyValues",
                    validators: [n.Validators.anyArrayValidator]
                  }, {
                    field: "children",
                    validators: [n.Validators.hierarchyFilterValuesValidator]
                  }, {
                    field: "operator",
                    validators: [n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.HierarchyFilterNodeValidator = S;

              var F = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  return null == a ? null : t.prototype.validate.call(this, a, e, r) || n.Validators.anyFilterValidator.validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.FilterValidator = F;

              var T = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "filtersOperation",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.filtersOperationsUpdateValidator]
                  }, {
                    field: "filters",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.filtersArrayValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.UpdateFiltersRequestValidator = T;

              var P = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "filtersOperation",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.filtersOperationsRemoveAllValidator]
                  }, {
                    field: "filters",
                    validators: [n.Validators.fieldForbiddenValidator, n.Validators.filtersArrayValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.RemoveFiltersRequestValidator = P;

              var C = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "value",
                    validators: [n.Validators.anyValueValidator]
                  }, {
                    field: "operator",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.ConditionItemValidator = C;

              var R = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "operation",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.filtersOperationsUpdateValidator]
                  }, {
                    field: "filters",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.filtersArrayValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.OnLoadFiltersBaseValidator = R;

              var k = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "operation",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.filtersOperationsRemoveAllValidator]
                  }, {
                    field: "filters",
                    validators: [n.Validators.fieldForbiddenValidator, n.Validators.filtersArrayValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.OnLoadFiltersBaseRemoveOperationValidator = k;

              var M = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "allPages",
                    validators: [n.Validators.onLoadFiltersBaseValidator]
                  }, {
                    field: "currentPage",
                    validators: [n.Validators.onLoadFiltersBaseValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.OnLoadFiltersValidator = M;
            }, function (t, a, e) {
              var _r11,
                  i = this && this.__extends || (_r11 = function r(t, a) {
                return _r11 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r11(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r11(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.PageLayoutValidator = a.DisplayStateValidator = a.VisualLayoutValidator = a.CustomLayoutValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "pageSize",
                    validators: [n.Validators.pageSizeValidator]
                  }, {
                    field: "displayOption",
                    validators: [n.Validators.customLayoutDisplayOptionValidator]
                  }, {
                    field: "pagesLayout",
                    validators: [n.Validators.pagesLayoutValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.CustomLayoutValidator = d;

              var s = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "x",
                    validators: [n.Validators.numberValidator]
                  }, {
                    field: "y",
                    validators: [n.Validators.numberValidator]
                  }, {
                    field: "z",
                    validators: [n.Validators.numberValidator]
                  }, {
                    field: "width",
                    validators: [n.Validators.numberValidator]
                  }, {
                    field: "height",
                    validators: [n.Validators.numberValidator]
                  }, {
                    field: "displayState",
                    validators: [n.Validators.displayStateValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.VisualLayoutValidator = s;

              var u = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "mode",
                    validators: [n.Validators.displayStateModeValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.DisplayStateValidator = u;

              var p = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "visualsLayout",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.pageLayoutValidator]
                  }, {
                    field: "defaultLayout",
                    validators: [n.Validators.visualLayoutValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.PageLayoutValidator = p;
            }, function (t, a, e) {
              var _r12,
                  i = this && this.__extends || (_r12 = function r(t, a) {
                return _r12 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r12(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r12(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.PageViewFieldValidator = a.PageValidator = a.CustomPageSizeValidator = a.PageSizeValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "type",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.pageSizeTypeValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.PageSizeValidator = d;

              var s = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "width",
                    validators: [n.Validators.numberValidator]
                  }, {
                    field: "height",
                    validators: [n.Validators.numberValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(d);

              a.CustomPageSizeValidator = s;

              var u = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "name",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.PageValidator = u;

              var p = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  return null == a ? null : t.prototype.validate.call(this, a, e, r) || (["actualSize", "fitToWidth", "oneColumn"].indexOf(a) < 0 ? [{
                    message: 'pageView must be a string with one of the following values: "actualSize", "fitToWidth", "oneColumn"'
                  }] : null);
                }, a;
              }(l.StringValidator);

              a.PageViewFieldValidator = p;
            }, function (t, a, e) {
              var _r13,
                  i = this && this.__extends || (_r13 = function r(t, a) {
                return _r13 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r13(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r13(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.VisualizationsPaneValidator = a.SyncSlicersPaneValidator = a.SelectionPaneValidator = a.PageNavigationPaneValidator = a.FiltersPaneValidator = a.FieldsPaneValidator = a.BookmarksPaneValidator = a.QnaPanesValidator = a.ReportPanesValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "bookmarks",
                    validators: [n.Validators.bookmarksPaneValidator]
                  }, {
                    field: "fields",
                    validators: [n.Validators.fieldsPaneValidator]
                  }, {
                    field: "filters",
                    validators: [n.Validators.filtersPaneValidator]
                  }, {
                    field: "pageNavigation",
                    validators: [n.Validators.pageNavigationPaneValidator]
                  }, {
                    field: "selection",
                    validators: [n.Validators.selectionPaneValidator]
                  }, {
                    field: "syncSlicers",
                    validators: [n.Validators.syncSlicersPaneValidator]
                  }, {
                    field: "visualizations",
                    validators: [n.Validators.visualizationsPaneValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.ReportPanesValidator = d;

              var s = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "filters",
                    validators: [n.Validators.filtersPaneValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.QnaPanesValidator = s;

              var u = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "visible",
                    validators: [n.Validators.booleanValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.BookmarksPaneValidator = u;

              var p = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "expanded",
                    validators: [n.Validators.booleanValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.FieldsPaneValidator = p;

              var c = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "visible",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "expanded",
                    validators: [n.Validators.booleanValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.FiltersPaneValidator = c;

              var f = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "visible",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "position",
                    validators: [n.Validators.pageNavigationPositionValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.PageNavigationPaneValidator = f;

              var V = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "visible",
                    validators: [n.Validators.booleanValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.SelectionPaneValidator = V;

              var v = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "visible",
                    validators: [n.Validators.booleanValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.SyncSlicersPaneValidator = v;

              var y = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "expanded",
                    validators: [n.Validators.booleanValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.VisualizationsPaneValidator = y;
            }, function (t, a, e) {
              var _r14,
                  i = this && this.__extends || (_r14 = function r(t, a) {
                return _r14 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r14(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r14(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.QnaInterpretInputDataValidator = a.QnaSettingsValidator = a.LoadQnaValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "accessToken",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "datasetIds",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringArrayValidator]
                  }, {
                    field: "question",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "viewMode",
                    validators: [n.Validators.viewModeValidator]
                  }, {
                    field: "settings",
                    validators: [n.Validators.qnaSettingValidator]
                  }, {
                    field: "tokenType",
                    validators: [n.Validators.tokenTypeValidator]
                  }, {
                    field: "groupId",
                    validators: [n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.LoadQnaValidator = d;

              var s = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "filterPaneEnabled",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "hideErrors",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "panes",
                    validators: [n.Validators.qnaPanesValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.QnaSettingsValidator = s;

              var u = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "datasetIds",
                    validators: [n.Validators.stringArrayValidator]
                  }, {
                    field: "question",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.QnaInterpretInputDataValidator = u;
            }, function (t, a, e) {
              var _r15,
                  i = this && this.__extends || (_r15 = function r(t, a) {
                return _r15 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r15(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r15(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.ReportCreateValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "accessToken",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "datasetId",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "groupId",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "tokenType",
                    validators: [n.Validators.tokenTypeValidator]
                  }, {
                    field: "theme",
                    validators: [n.Validators.customThemeValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.ReportCreateValidator = d;
            }, function (t, a, e) {
              var _r16,
                  i = this && this.__extends || (_r16 = function r(t, a) {
                return _r16 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r16(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r16(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.ReportLoadValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "accessToken",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "id",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "groupId",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "settings",
                    validators: [n.Validators.settingsValidator]
                  }, {
                    field: "pageName",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "filters",
                    validators: [n.Validators.reportLoadFiltersValidator]
                  }, {
                    field: "permissions",
                    validators: [n.Validators.permissionsValidator]
                  }, {
                    field: "viewMode",
                    validators: [n.Validators.viewModeValidator]
                  }, {
                    field: "tokenType",
                    validators: [n.Validators.tokenTypeValidator]
                  }, {
                    field: "bookmark",
                    validators: [n.Validators.applyBookmarkValidator]
                  }, {
                    field: "theme",
                    validators: [n.Validators.customThemeValidator]
                  }, {
                    field: "embedUrl",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "datasetBinding",
                    validators: [n.Validators.datasetBindingValidator]
                  }, {
                    field: "contrastMode",
                    validators: [n.Validators.contrastModeValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.ReportLoadValidator = d;
            }, function (t, a, e) {
              var _r17,
                  i = this && this.__extends || (_r17 = function r(t, a) {
                return _r17 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r17(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r17(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.ReportParameterFieldsValidator = a.PaginatedReportLoadValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "accessToken",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "id",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "groupId",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "settings",
                    validators: [n.Validators.paginatedReportsettingsValidator]
                  }, {
                    field: "tokenType",
                    validators: [n.Validators.tokenTypeValidator]
                  }, {
                    field: "embedUrl",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "type",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "parameterValues",
                    validators: [n.Validators.parameterValuesArrayValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.PaginatedReportLoadValidator = d;

              var s = function () {
                function t() {}

                return t.prototype.validate = function (t, a, e) {
                  if (null == t) return null;
                  var r = [{
                    field: "name",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "value",
                    validators: [n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(r).validate(t, a, e);
                }, t;
              }();

              a.ReportParameterFieldsValidator = s;
            }, function (t, a, e) {
              var _r18,
                  i = this && this.__extends || (_r18 = function r(t, a) {
                return _r18 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r18(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r18(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.SaveAsParametersValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "name",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.SaveAsParametersValidator = d;
            }, function (t, a, e) {
              var _r19,
                  i = this && this.__extends || (_r19 = function r(t, a) {
                return _r19 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r19(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r19(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.SlicerTargetSelectorValidator = a.VisualTypeSelectorValidator = a.VisualSelectorValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(4),
                  d = e(1),
                  s = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "$schema",
                    validators: [d.Validators.stringValidator, new n.SchemaValidator("http://powerbi.com/product/schema#visualSelector")]
                  }, {
                    field: "visualName",
                    validators: [d.Validators.fieldRequiredValidator, d.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.VisualSelectorValidator = s;

              var u = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "$schema",
                    validators: [d.Validators.fieldRequiredValidator, d.Validators.stringValidator, new n.SchemaValidator("http://powerbi.com/product/schema#visualTypeSelector")]
                  }, {
                    field: "visualType",
                    validators: [d.Validators.fieldRequiredValidator, d.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.VisualTypeSelectorValidator = u;

              var p = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "$schema",
                    validators: [d.Validators.fieldRequiredValidator, d.Validators.stringValidator, new n.SchemaValidator("http://powerbi.com/product/schema#slicerTargetSelector")]
                  }, {
                    field: "target",
                    validators: [d.Validators.fieldRequiredValidator, d.Validators.slicerTargetValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.SlicerTargetSelectorValidator = p;
            }, function (t, a, e) {
              var _r20,
                  i = this && this.__extends || (_r20 = function r(t, a) {
                return _r20 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r20(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r20(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.PaginatedReportSettingsValidator = a.SettingsValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "filterPaneEnabled",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "navContentPaneEnabled",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "bookmarksPaneEnabled",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "useCustomSaveAsDialog",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "extensions",
                    validators: [n.Validators.extensionsValidator]
                  }, {
                    field: "layoutType",
                    validators: [n.Validators.layoutTypeValidator]
                  }, {
                    field: "customLayout",
                    validators: [n.Validators.customLayoutValidator]
                  }, {
                    field: "background",
                    validators: [n.Validators.backgroundValidator]
                  }, {
                    field: "visualSettings",
                    validators: [n.Validators.visualSettingsValidator]
                  }, {
                    field: "hideErrors",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "commands",
                    validators: [n.Validators.commandsSettingsArrayValidator]
                  }, {
                    field: "hyperlinkClickBehavior",
                    validators: [n.Validators.hyperlinkClickBehaviorValidator]
                  }, {
                    field: "bars",
                    validators: [n.Validators.reportBarsValidator]
                  }, {
                    field: "panes",
                    validators: [n.Validators.reportPanesValidator]
                  }, {
                    field: "personalBookmarksEnabled",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "persistentFiltersEnabled",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "visualRenderedEvents",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "authoringHintsEnabled",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "printSettings",
                    validators: [n.Validators.printSettingsValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.SettingsValidator = d;

              var s = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "commands",
                    validators: [n.Validators.paginatedReportCommandsValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.PaginatedReportSettingsValidator = s;
            }, function (t, a, e) {
              var _r21,
                  i = this && this.__extends || (_r21 = function r(t, a) {
                return _r21 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r21(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r21(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.SlicerStateValidator = a.SlicerValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "selector",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.slicerSelectorValidator]
                  }, {
                    field: "state",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.slicerStateValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.SlicerValidator = d;

              var s = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "filters",
                    validators: [n.Validators.filtersArrayValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.SlicerStateValidator = s;
            }, function (t, a, e) {
              var _r22,
                  i = this && this.__extends || (_r22 = function r(t, a) {
                return _r22 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r22(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r22(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.TileLoadValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "accessToken",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "id",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "dashboardId",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "groupId",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "pageView",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "tokenType",
                    validators: [n.Validators.tokenTypeValidator]
                  }, {
                    field: "width",
                    validators: [n.Validators.numberValidator]
                  }, {
                    field: "height",
                    validators: [n.Validators.numberValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.TileLoadValidator = d;
            }, function (t, a, e) {
              var _r23,
                  i = this && this.__extends || (_r23 = function r(t, a) {
                return _r23 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r23(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r23(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.VisualHeaderValidator = a.VisualHeaderSettingsValidator = a.VisualSettingsValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "visualHeaders",
                    validators: [n.Validators.visualHeadersValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.VisualSettingsValidator = d;

              var s = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "visible",
                    validators: [n.Validators.booleanValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.VisualHeaderSettingsValidator = s;

              var u = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "settings",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.visualHeaderSettingsValidator]
                  }, {
                    field: "selector",
                    validators: [n.Validators.visualHeaderSelectorValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.VisualHeaderValidator = u;
            }, function (t, a) {
              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.AnyOfValidator = void 0;

              var e = function () {
                function t(t) {
                  this.validators = t;
                }

                return t.prototype.validate = function (t, a, e) {
                  if (null == t) return null;

                  for (var r = !1, i = 0, o = this.validators; i < o.length; i++) {
                    if (!o[i].validate(t, a, e)) {
                      r = !0;
                      break;
                    }
                  }

                  return r ? null : [{
                    message: e + " property is invalid",
                    path: (a ? a + "." : "") + e,
                    keyword: "invalid"
                  }];
                }, t;
              }();

              a.AnyOfValidator = e;
            }, function (t, a) {
              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.FieldForbiddenValidator = void 0;

              var e = function () {
                function t() {}

                return t.prototype.validate = function (t, a, e) {
                  return void 0 !== t ? [{
                    message: e + " is forbidden",
                    path: (a ? a + "." : "") + e,
                    keyword: "forbidden"
                  }] : null;
                }, t;
              }();

              a.FieldForbiddenValidator = e;
            }, function (t, a) {
              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.FieldRequiredValidator = void 0;

              var e = function () {
                function t() {}

                return t.prototype.validate = function (t, a, e) {
                  return null == t ? [{
                    message: e + " is required",
                    path: (a ? a + "." : "") + e,
                    keyword: "required"
                  }] : null;
                }, t;
              }();

              a.FieldRequiredValidator = e;
            }, function (t, a, e) {
              var _r24,
                  i = this && this.__extends || (_r24 = function r(t, a) {
                return _r24 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r24(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r24(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.MapValidator = void 0;

              var o = function (t) {
                function a(a, e) {
                  var r = t.call(this) || this;
                  return r.keyValidators = a, r.valueValidators = e, r;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;

                  for (var o in a) {
                    if (a.hasOwnProperty(o)) {
                      for (var l = (e ? e + "." : "") + r + "." + o, n = 0, d = this.keyValidators; n < d.length; n++) {
                        if (i = d[n].validate(o, l, r)) return i;
                      }

                      for (var s = 0, u = this.valueValidators; s < u.length; s++) {
                        if (i = u[s].validate(a[o], l, r)) return i;
                      }
                    }
                  }

                  return null;
                }, a;
              }(e(4).ObjectValidator);

              a.MapValidator = o;
            }, function (t, a, e) {
              var _r25,
                  i = this && this.__extends || (_r25 = function r(t, a) {
                return _r25 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r25(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r25(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.ParametersPanelValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "expanded",
                    validators: [n.Validators.booleanValidator]
                  }, {
                    field: "enabled",
                    validators: [n.Validators.booleanValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.ParametersPanelValidator = d;
            }, function (t, a, e) {
              var _r26,
                  i = this && this.__extends || (_r26 = function r(t, a) {
                return _r26 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r26(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r26(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.TableDataValidator = a.TableSchemaValidator = a.ColumnSchemaValidator = a.CredentialsValidator = a.DatasourceConnectionConfigValidator = a.DatasetCreateConfigValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "locale",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "mashupDocument",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "datasourceConnectionConfig",
                    validators: [n.Validators.datasourceConnectionConfigValidator]
                  }, {
                    field: "tableSchemaList",
                    validators: [n.Validators.tableSchemaListValidator]
                  }, {
                    field: "data",
                    validators: [n.Validators.tableDataArrayValidator]
                  }];
                  return (i = new o.MultipleFieldsValidator(l).validate(a, e, r)) || (a.datasourceConnectionConfig && null == a.mashupDocument ? [{
                    message: "mashupDocument cannot be empty when datasourceConnectionConfig is presented"
                  }] : a.data && null == a.tableSchemaList ? [{
                    message: "tableSchemaList cannot be empty when data is provided"
                  }] : null == a.data && null == a.mashupDocument ? [{
                    message: "At least one of data or mashupDocument must be provided"
                  }] : void 0);
                }, a;
              }(l.ObjectValidator);

              a.DatasetCreateConfigValidator = d;

              var s = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "dataCacheMode",
                    validators: [n.Validators.dataCacheModeValidator]
                  }, {
                    field: "credentials",
                    validators: [n.Validators.credentialsValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.DatasourceConnectionConfigValidator = s;

              var u = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "credentialType",
                    validators: [n.Validators.credentialTypeValidator]
                  }, {
                    field: "credentialDetails",
                    validators: [n.Validators.credentialDetailsValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.CredentialsValidator = u;

              var p = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "name",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "displayName",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "dataType",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.ColumnSchemaValidator = p;

              var c = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "name",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "columns",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.columnSchemaArrayValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.TableSchemaValidator = c;

              var f = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "name",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "rows",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.rawDataValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.TableDataValidator = f;
            }, function (t, a, e) {
              var _r27,
                  i = this && this.__extends || (_r27 = function r(t, a) {
                return _r27 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r27(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r27(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.QuickCreateValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = e(1),
                  d = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var l = [{
                    field: "accessToken",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.stringValidator]
                  }, {
                    field: "groupId",
                    validators: [n.Validators.stringValidator]
                  }, {
                    field: "tokenType",
                    validators: [n.Validators.tokenTypeValidator]
                  }, {
                    field: "theme",
                    validators: [n.Validators.customThemeValidator]
                  }, {
                    field: "datasetCreateConfig",
                    validators: [n.Validators.fieldRequiredValidator, n.Validators.datasetCreateConfigValidator]
                  }];
                  return new o.MultipleFieldsValidator(l).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.QuickCreateValidator = d;
            }, function (t, a, e) {
              var _r28,
                  i = this && this.__extends || (_r28 = function r(t, a) {
                return _r28 = Object.setPrototypeOf || {
                  __proto__: []
                } instanceof Array && function (t, a) {
                  t.__proto__ = a;
                } || function (t, a) {
                  for (var e in a) {
                    Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
                  }
                }, _r28(t, a);
              }, function (t, a) {
                if ("function" != typeof a && null !== a) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");

                function e() {
                  this.constructor = t;
                }

                _r28(t, a), t.prototype = null === a ? Object.create(a) : (e.prototype = a.prototype, new e());
              });

              Object.defineProperty(a, "__esModule", {
                value: !0
              }), a.PrintSettingsValidator = void 0;

              var o = e(3),
                  l = e(4),
                  n = function (t) {
                function a() {
                  return null !== t && t.apply(this, arguments) || this;
                }

                return i(a, t), a.prototype.validate = function (a, e, r) {
                  if (null == a) return null;
                  var i = t.prototype.validate.call(this, a, e, r);
                  if (i) return i;
                  var n = [{
                    field: "browserPrintAdjustmentsMode",
                    validators: [new l.EnumValidator([0, 1])]
                  }];
                  return new o.MultipleFieldsValidator(n).validate(a, e, r);
                }, a;
              }(l.ObjectValidator);

              a.PrintSettingsValidator = n;
            }],
                a = {},
                e = function e(r) {
              var i = a[r];
              if (void 0 !== i) return i.exports;
              var o = a[r] = {
                exports: {}
              };
              return t[r].call(o.exports, o, o.exports, e), o.exports;
            }(0);

            return e;
          }();
        }, t.exports = a();
      },
      890: function _(t) {
        "use strict";

        t.exports = e;
      },
      719: function _(t) {
        "use strict";

        t.exports = a;
      },
      156: function _(a) {
        "use strict";

        a.exports = t;
      }
    },
        i = {};

    function o(t) {
      var a = i[t];
      if (void 0 !== a) return a.exports;
      var e = i[t] = {
        exports: {}
      };
      return r[t].call(e.exports, e, e.exports, o), e.exports;
    }

    o.n = function (t) {
      var a = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return o.d(a, {
        a: a
      }), a;
    }, o.d = function (t, a) {
      for (var e in a) {
        o.o(a, e) && !o.o(t, e) && Object.defineProperty(t, e, {
          enumerable: !0,
          get: a[e]
        });
      }
    }, o.o = function (t, a) {
      return Object.prototype.hasOwnProperty.call(t, a);
    }, o.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    };
    var l = {};
    return function () {
      "use strict";

      o.r(l), o.d(l, {
        EmbedType: function EmbedType() {
          return a;
        },
        PowerBIEmbed: function PowerBIEmbed() {
          return f;
        }
      });

      var _t,
          a,
          e = o(156),
          r = o(719),
          i = o(149),
          n = o(890),
          d = o.n(n),
          s = (_t = function t(a, e) {
        return _t = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, a) {
          t.__proto__ = a;
        } || function (t, a) {
          for (var e in a) {
            Object.prototype.hasOwnProperty.call(a, e) && (t[e] = a[e]);
          }
        }, _t(a, e);
      }, function (a, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");

        function r() {
          this.constructor = a;
        }

        _t(a, e), a.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      }),
          u = function u(t, a, e, r) {
        return new (e || (e = Promise))(function (i, o) {
          function l(t) {
            try {
              d(r.next(t));
            } catch (t) {
              o(t);
            }
          }

          function n(t) {
            try {
              d(r.throw(t));
            } catch (t) {
              o(t);
            }
          }

          function d(t) {
            var a;
            t.done ? i(t.value) : (a = t.value, a instanceof e ? a : new e(function (t) {
              t(a);
            })).then(l, n);
          }

          d((r = r.apply(t, a || [])).next());
        });
      },
          p = function p(t, a) {
        var e,
            r,
            i,
            o,
            l = {
          label: 0,
          sent: function sent() {
            if (1 & i[0]) throw i[1];
            return i[1];
          },
          trys: [],
          ops: []
        };
        return o = {
          next: n(0),
          throw: n(1),
          return: n(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
          return this;
        }), o;

        function n(n) {
          return function (d) {
            return function (n) {
              if (e) throw new TypeError("Generator is already executing.");

              for (; o && (o = 0, n[0] && (l = 0)), l;) {
                try {
                  if (e = 1, r && (i = 2 & n[0] ? r.return : n[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, n[1])).done) return i;

                  switch (r = 0, i && (n = [2 & n[0], i.value]), n[0]) {
                    case 0:
                    case 1:
                      i = n;
                      break;

                    case 4:
                      return l.label++, {
                        value: n[1],
                        done: !1
                      };

                    case 5:
                      l.label++, r = n[1], n = [0];
                      continue;

                    case 7:
                      n = l.ops.pop(), l.trys.pop();
                      continue;

                    default:
                      if (!((i = (i = l.trys).length > 0 && i[i.length - 1]) || 6 !== n[0] && 2 !== n[0])) {
                        l = 0;
                        continue;
                      }

                      if (3 === n[0] && (!i || n[1] > i[0] && n[1] < i[3])) {
                        l.label = n[1];
                        break;
                      }

                      if (6 === n[0] && l.label < i[1]) {
                        l.label = i[1], i = n;
                        break;
                      }

                      if (i && l.label < i[2]) {
                        l.label = i[2], l.ops.push(n);
                        break;
                      }

                      i[2] && l.ops.pop(), l.trys.pop();
                      continue;
                  }

                  n = a.call(t, l);
                } catch (t) {
                  n = [6, t], r = 0;
                } finally {
                  e = i = 0;
                }
              }

              if (5 & n[0]) throw n[1];
              return {
                value: n[0] ? n[1] : void 0,
                done: !0
              };
            }([n, d]);
          };
        }
      },
          c = function c(t, a, e) {
        if (e || 2 === arguments.length) for (var r, i = 0, o = a.length; i < o; i++) {
          !r && i in a || (r || (r = Array.prototype.slice.call(a, 0, i)), r[i] = a[i]);
        }
        return t.concat(r || Array.prototype.slice.call(a));
      };

      !function (t) {
        t.Create = "create", t.Report = "report", t.Dashboard = "dashboard", t.Tile = "tile", t.Qna = "qna", t.Visual = "visual";
      }(a || (a = {}));

      var f = function (t) {
        function o(a) {
          var i = t.call(this, a) || this;
          return i.containerRef = e.createRef(), i.prevEventHandlerMapString = "", i.props.service ? i.powerbi = i.props.service : i.powerbi = new r.service.Service(r.factories.hpmFactory, r.factories.wpmpFactory, r.factories.routerFactory), i.powerbi.setSdkInfo("powerbi-client-react", "1.4.0"), i;
        }

        return s(o, t), Object.defineProperty(o.prototype, "embed", {
          get: function get() {
            return this._embed;
          },
          set: function set(t) {
            this._embed = t, this.invokeGetEmbedCallback();
          },
          enumerable: !1,
          configurable: !0
        }), o.prototype.componentDidMount = function () {
          this.containerRef.current && (this.props.embedConfig.accessToken && this.props.embedConfig.embedUrl ? this.embedEntity() : this.embed = this.powerbi.bootstrap(this.containerRef.current, this.props.embedConfig)), this.props.eventHandlers && this.embed && this.setEventHandlers(this.embed, this.props.eventHandlers);
        }, o.prototype.componentDidUpdate = function (t) {
          return u(this, void 0, void 0, function () {
            var e, r, o, l;
            return p(this, function (n) {
              switch (n.label) {
                case 0:
                  return this.embedOrUpdateAccessToken(t), this.props.eventHandlers && this.embed && this.setEventHandlers(this.embed, this.props.eventHandlers), d()(this.props.embedConfig.settings, t.embedConfig.settings) ? [3, 2] : [4, this.updateSettings()];

                case 1:
                  n.sent(), n.label = 2;

                case 2:
                  if (this.props.embedConfig.type !== a.Report) return [3, 11];
                  n.label = 3;

                case 3:
                  return n.trys.push([3, 10,, 11]), e = this.props.embedConfig, r = e.filters, o = t.embedConfig, e.pageName && e.pageName !== o.pageName ? [4, this.embed.setPage(e.pageName)] : [3, 5];

                case 4:
                  n.sent(), n.label = 5;

                case 5:
                  return !r || d()(r, o.filters) ? [3, 7] : [4, this.embed.updateFilters(i.FiltersOperations.Replace, r)];

                case 6:
                  return n.sent(), [3, 9];

                case 7:
                  return r || !o.filters ? [3, 9] : [4, this.embed.updateFilters(i.FiltersOperations.RemoveAll)];

                case 8:
                  n.sent(), n.label = 9;

                case 9:
                  return [3, 11];

                case 10:
                  return l = n.sent(), console.error(l), [3, 11];

                case 11:
                  return [2];
              }
            });
          });
        }, o.prototype.componentWillUnmount = function () {
          this.containerRef.current && this.powerbi.reset(this.containerRef.current), this.prevEventHandlerMapString = "";
        }, o.prototype.render = function () {
          return e.createElement("div", {
            ref: this.containerRef,
            className: this.props.cssClassName
          });
        }, o.prototype.embedEntity = function () {
          this.containerRef.current && (this.props.phasedEmbedding && this.props.embedConfig.type === a.Report ? this.embed = this.powerbi.load(this.containerRef.current, this.props.embedConfig) : (this.props.phasedEmbedding && console.error("Phased embedding is not supported for type ".concat(this.props.embedConfig.type)), this.props.embedConfig.type === a.Create ? this.embed = this.powerbi.createReport(this.containerRef.current, this.props.embedConfig) : this.embed = this.powerbi.embed(this.containerRef.current, this.props.embedConfig)));
        }, o.prototype.embedOrUpdateAccessToken = function (t) {
          return u(this, void 0, void 0, function () {
            var a;
            return p(this, function (e) {
              switch (e.label) {
                case 0:
                  return this.props.embedConfig.accessToken && this.props.embedConfig.embedUrl ? !this.containerRef.current || t.embedConfig.accessToken && this.props.embedConfig.embedUrl === t.embedConfig.embedUrl ? [3, 1] : (this.embedEntity(), [3, 5]) : [2];

                case 1:
                  if (this.props.embedConfig.accessToken === t.embedConfig.accessToken || this.props.embedConfig.embedUrl !== t.embedConfig.embedUrl || !this.embed) return [3, 5];
                  e.label = 2;

                case 2:
                  return e.trys.push([2, 4,, 5]), [4, this.embed.setAccessToken(this.props.embedConfig.accessToken)];

                case 3:
                  return e.sent(), [3, 5];

                case 4:
                  return a = e.sent(), console.error("setAccessToken error:\n", a), [3, 5];

                case 5:
                  return [2];
              }
            });
          });
        }, o.prototype.setEventHandlers = function (t, e) {
          var i = this,
              o = function (t) {
            if (!t) return "";
            var a = Array.from(t);
            return JSON.stringify(a.map(function (t) {
              return [t[0], t[1] ? t[1].toString() : ""];
            }));
          }(this.props.eventHandlers);

          if (this.prevEventHandlerMapString !== o) {
            this.prevEventHandlerMapString = o;
            var l = r.Embed.allowedEvents,
                n = t.embedtype;

            switch (n) {
              case a.Create:
                break;

              case a.Report:
                l = c(c([], l, !0), r.Report.allowedEvents, !0);
                break;

              case a.Dashboard:
                l = c(c([], l, !0), r.Dashboard.allowedEvents, !0);
                break;

              case a.Tile:
                l = c(c([], l, !0), r.Tile.allowedEvents, !0);
                break;

              case a.Qna:
                l = c(c([], l, !0), r.Qna.allowedEvents, !0);
                break;

              case a.Visual:
                l = c(c([], l, !0), r.Visual.allowedEvents, !0);
                break;

              default:
                console.error("Invalid embed type ".concat(n));
            }

            var d = [];
            e.forEach(function (a, e) {
              l.includes(e) ? (t.off(e), a && t.on(e, function (t) {
                a(t, i.embed);
              })) : d.push(e);
            }), d.length && console.error("Following events are invalid: ".concat(d.join(",")));
          }
        }, o.prototype.invokeGetEmbedCallback = function () {
          this.props.getEmbeddedComponent && this.embed && this.props.getEmbeddedComponent(this.embed);
        }, o.prototype.updateSettings = function () {
          return u(this, void 0, void 0, function () {
            var t, e;
            return p(this, function (r) {
              switch (r.label) {
                case 0:
                  if (!this.embed || !this.props.embedConfig.settings) return [2];

                  switch (this.props.embedConfig.type) {
                    case a.Report:
                      return [3, 1];

                    case a.Dashboard:
                    case a.Tile:
                    case a.Qna:
                    case a.Visual:
                      return [3, 6];
                  }

                  return [3, 7];

                case 1:
                  t = this.props.embedConfig.settings, r.label = 2;

                case 2:
                  return r.trys.push([2, 4,, 5]), [4, this.embed.updateSettings(t)];

                case 3:
                  return r.sent(), [3, 5];

                case 4:
                  return e = r.sent(), console.error("Error in method updateSettings: ".concat(e)), [3, 5];

                case 5:
                case 6:
                  return [3, 8];

                case 7:
                  console.error("Invalid embed type ".concat(this.props.embedConfig.type)), r.label = 8;

                case 8:
                  return [2];
              }
            });
          });
        }, o;
      }(e.Component);
    }(), l;
  }();
}); // SIG // Begin signature block
// SIG // MIIrdwYJKoZIhvcNAQcCoIIraDCCK2QCAQExDzANBglg
// SIG // hkgBZQMEAgEFADB3BgorBgEEAYI3AgEEoGkwZzAyBgor
// SIG // BgEEAYI3AgEeMCQCAQEEEBDgyQbOONQRoqMAEEvTUJAC
// SIG // AQACAQACAQACAQACAQAwMTANBglghkgBZQMEAgEFAAQg
// SIG // bAE2PHOCwmymcwYlXV9p4at/rhXPgIPeia11/PQSumig
// SIG // ghFuMIIIfjCCB2agAwIBAgITNgAAAahTK9ZQq6y5UwAC
// SIG // AAABqDANBgkqhkiG9w0BAQsFADBBMRMwEQYKCZImiZPy
// SIG // LGQBGRYDR0JMMRMwEQYKCZImiZPyLGQBGRYDQU1FMRUw
// SIG // EwYDVQQDEwxBTUUgQ1MgQ0EgMDEwHhcNMjIwNjEwMTgy
// SIG // NzAzWhcNMjMwNjEwMTgyNzAzWjAkMSIwIAYDVQQDExlN
// SIG // aWNyb3NvZnQgQXp1cmUgQ29kZSBTaWduMIIBIjANBgkq
// SIG // hkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAnEdeHxP889b7
// SIG // mrwL0Z0koWl4LoJ+zeHJ7UDmhaQAxyRIIw9tXSK910U/
// SIG // pTle2lfbvL9vZR1U8zyRwy6WaVNT/rh+wOm9AKqrsbaB
// SIG // qlCsTRliD/TIgibyDuKIf/aV+Aok1yvoWVg2eNn/06XE
// SIG // bXA/k554/MzRFwxHJNnO9dGc8hke+UZxb94AZB6JWfXQ
// SIG // 3xzYYQtPQmVsTI2iQ/aDYkkS+nIgs/IjbConhB93V4oc
// SIG // 4rL8r9C5D29kDOZRQ2Y2/1eqXV5wb7QSdahpxk3457cf
// SIG // caTGsmz6nPQq7DqO9RqDO5dYD22V5bGQkf5wMhC0jlQq
// SIG // 1qFAhbD3nkXka5eErruzcwIDAQABo4IFijCCBYYwKQYJ
// SIG // KwYBBAGCNxUKBBwwGjAMBgorBgEEAYI3WwEBMAoGCCsG
// SIG // AQUFBwMDMD0GCSsGAQQBgjcVBwQwMC4GJisGAQQBgjcV
// SIG // CIaQ4w2E1bR4hPGLPoWb3RbOnRKBYIPdzWaGlIwyAgFk
// SIG // AgEMMIICdgYIKwYBBQUHAQEEggJoMIICZDBiBggrBgEF
// SIG // BQcwAoZWaHR0cDovL2NybC5taWNyb3NvZnQuY29tL3Br
// SIG // aWluZnJhL0NlcnRzL0JZMlBLSUNTQ0EwMS5BTUUuR0JM
// SIG // X0FNRSUyMENTJTIwQ0ElMjAwMSgyKS5jcnQwUgYIKwYB
// SIG // BQUHMAKGRmh0dHA6Ly9jcmwxLmFtZS5nYmwvYWlhL0JZ
// SIG // MlBLSUNTQ0EwMS5BTUUuR0JMX0FNRSUyMENTJTIwQ0El
// SIG // MjAwMSgyKS5jcnQwUgYIKwYBBQUHMAKGRmh0dHA6Ly9j
// SIG // cmwyLmFtZS5nYmwvYWlhL0JZMlBLSUNTQ0EwMS5BTUUu
// SIG // R0JMX0FNRSUyMENTJTIwQ0ElMjAwMSgyKS5jcnQwUgYI
// SIG // KwYBBQUHMAKGRmh0dHA6Ly9jcmwzLmFtZS5nYmwvYWlh
// SIG // L0JZMlBLSUNTQ0EwMS5BTUUuR0JMX0FNRSUyMENTJTIw
// SIG // Q0ElMjAwMSgyKS5jcnQwUgYIKwYBBQUHMAKGRmh0dHA6
// SIG // Ly9jcmw0LmFtZS5nYmwvYWlhL0JZMlBLSUNTQ0EwMS5B
// SIG // TUUuR0JMX0FNRSUyMENTJTIwQ0ElMjAwMSgyKS5jcnQw
// SIG // ga0GCCsGAQUFBzAChoGgbGRhcDovLy9DTj1BTUUlMjBD
// SIG // UyUyMENBJTIwMDEsQ049QUlBLENOPVB1YmxpYyUyMEtl
// SIG // eSUyMFNlcnZpY2VzLENOPVNlcnZpY2VzLENOPUNvbmZp
// SIG // Z3VyYXRpb24sREM9QU1FLERDPUdCTD9jQUNlcnRpZmlj
// SIG // YXRlP2Jhc2U/b2JqZWN0Q2xhc3M9Y2VydGlmaWNhdGlv
// SIG // bkF1dGhvcml0eTAdBgNVHQ4EFgQUUchb+1j7hxhVLQdr
// SIG // TBwsRVxqi/IwDgYDVR0PAQH/BAQDAgeAMEUGA1UdEQQ+
// SIG // MDykOjA4MR4wHAYDVQQLExVNaWNyb3NvZnQgQ29ycG9y
// SIG // YXRpb24xFjAUBgNVBAUTDTIzNjE2Nys0NzA4NjAwggHm
// SIG // BgNVHR8EggHdMIIB2TCCAdWgggHRoIIBzYY/aHR0cDov
// SIG // L2NybC5taWNyb3NvZnQuY29tL3BraWluZnJhL0NSTC9B
// SIG // TUUlMjBDUyUyMENBJTIwMDEoMikuY3JshjFodHRwOi8v
// SIG // Y3JsMS5hbWUuZ2JsL2NybC9BTUUlMjBDUyUyMENBJTIw
// SIG // MDEoMikuY3JshjFodHRwOi8vY3JsMi5hbWUuZ2JsL2Ny
// SIG // bC9BTUUlMjBDUyUyMENBJTIwMDEoMikuY3JshjFodHRw
// SIG // Oi8vY3JsMy5hbWUuZ2JsL2NybC9BTUUlMjBDUyUyMENB
// SIG // JTIwMDEoMikuY3JshjFodHRwOi8vY3JsNC5hbWUuZ2Js
// SIG // L2NybC9BTUUlMjBDUyUyMENBJTIwMDEoMikuY3JshoG9
// SIG // bGRhcDovLy9DTj1BTUUlMjBDUyUyMENBJTIwMDEoMiks
// SIG // Q049QlkyUEtJQ1NDQTAxLENOPUNEUCxDTj1QdWJsaWMl
// SIG // MjBLZXklMjBTZXJ2aWNlcyxDTj1TZXJ2aWNlcyxDTj1D
// SIG // b25maWd1cmF0aW9uLERDPUFNRSxEQz1HQkw/Y2VydGlm
// SIG // aWNhdGVSZXZvY2F0aW9uTGlzdD9iYXNlP29iamVjdENs
// SIG // YXNzPWNSTERpc3RyaWJ1dGlvblBvaW50MB8GA1UdIwQY
// SIG // MBaAFJZRhOBrb3v+2Aarw/KF5imuavnUMB8GA1UdJQQY
// SIG // MBYGCisGAQQBgjdbAQEGCCsGAQUFBwMDMA0GCSqGSIb3
// SIG // DQEBCwUAA4IBAQAOoFAbE6qv+1RAKHjMn56sREYNiKvh
// SIG // i11baGKOgpeVXuKztX5x9fQ2/DpXdUOkVe0w6cVoute2
// SIG // 4WQACXKU+8ANjEMqaJq5DqsR52Q86V6LvjUQwMSfNgnj
// SIG // nb+mktUX1s8gNAQ2NUWsqG+Q0cmKbEGNFjnbsFvCKgDH
// SIG // OFHVJaYb5tNCU0nkWkMn1aA0y78u2wLvaQhSSx3I2A8O
// SIG // WLXWXahlAhV8ZEF04UatM/QwA5DubCgiUwK/TCXfRohY
// SIG // IouOD4h4MQ533o0sC3kVzvhSXdk2DXmgyBqzHrP+tJPQ
// SIG // A8IK5AJweyeJrKpdN39ZxV961rru4GXgQMfZ4L6+5v09
// SIG // zP/7MIII6DCCBtCgAwIBAgITHwAAAFHqj/accwyoOwAA
// SIG // AAAAUTANBgkqhkiG9w0BAQsFADA8MRMwEQYKCZImiZPy
// SIG // LGQBGRYDR0JMMRMwEQYKCZImiZPyLGQBGRYDQU1FMRAw
// SIG // DgYDVQQDEwdhbWVyb290MB4XDTIxMDUyMTE4NDQxNFoX
// SIG // DTI2MDUyMTE4NTQxNFowQTETMBEGCgmSJomT8ixkARkW
// SIG // A0dCTDETMBEGCgmSJomT8ixkARkWA0FNRTEVMBMGA1UE
// SIG // AxMMQU1FIENTIENBIDAxMIIBIjANBgkqhkiG9w0BAQEF
// SIG // AAOCAQ8AMIIBCgKCAQEAyZpSCX0Bno1W1yqXMhT6BUlJ
// SIG // ZWpa4p3xFeiTHO4vm2Q6C/azR5xwxnyYHrkSGDtS2P9X
// SIG // +KDE64V20mmEQkubxnPNeOVnE2RvdPGxgwlq+BhS3ONd
// SIG // VsQPj79q7XgHM9HhzB9+qk0PC9KN1zm9p/seyiRS6JF1
// SIG // dbOqRf1pUl7FAVxmgiCFgV8hHIb/rDPXig7FDi3S0yEx
// SIG // 2CUDVpIq8jEhG8anUFE1WYxM+ni0S5KHwwKPKV4qyGDo
// SIG // DO+9AmDoma3Chyu5WDlW5cdtqXTWsGPE3umtnX6Amlld
// SIG // UFLms4OVR4guKf+n5LIBCC6bTiocfXPomqYjYTKx7AGM
// SIG // faVLaaXmhQIDAQABo4IE3DCCBNgwEgYJKwYBBAGCNxUB
// SIG // BAUCAwIAAjAjBgkrBgEEAYI3FQIEFgQUEmgkQiFHy9Rr
// SIG // vjHPIKTACyN/P0cwHQYDVR0OBBYEFJZRhOBrb3v+2Aar
// SIG // w/KF5imuavnUMIIBBAYDVR0lBIH8MIH5BgcrBgEFAgMF
// SIG // BggrBgEFBQcDAQYIKwYBBQUHAwIGCisGAQQBgjcUAgEG
// SIG // CSsGAQQBgjcVBgYKKwYBBAGCNwoDDAYJKwYBBAGCNxUG
// SIG // BggrBgEFBQcDCQYIKwYBBQUIAgIGCisGAQQBgjdAAQEG
// SIG // CysGAQQBgjcKAwQBBgorBgEEAYI3CgMEBgkrBgEEAYI3
// SIG // FQUGCisGAQQBgjcUAgIGCisGAQQBgjcUAgMGCCsGAQUF
// SIG // BwMDBgorBgEEAYI3WwEBBgorBgEEAYI3WwIBBgorBgEE
// SIG // AYI3WwMBBgorBgEEAYI3WwUBBgorBgEEAYI3WwQBBgor
// SIG // BgEEAYI3WwQCMBkGCSsGAQQBgjcUAgQMHgoAUwB1AGIA
// SIG // QwBBMAsGA1UdDwQEAwIBhjASBgNVHRMBAf8ECDAGAQH/
// SIG // AgEAMB8GA1UdIwQYMBaAFCleUV5krjS566ycDaeMdQHR
// SIG // CQsoMIIBaAYDVR0fBIIBXzCCAVswggFXoIIBU6CCAU+G
// SIG // MWh0dHA6Ly9jcmwubWljcm9zb2Z0LmNvbS9wa2lpbmZy
// SIG // YS9jcmwvYW1lcm9vdC5jcmyGI2h0dHA6Ly9jcmwyLmFt
// SIG // ZS5nYmwvY3JsL2FtZXJvb3QuY3JshiNodHRwOi8vY3Js
// SIG // My5hbWUuZ2JsL2NybC9hbWVyb290LmNybIYjaHR0cDov
// SIG // L2NybDEuYW1lLmdibC9jcmwvYW1lcm9vdC5jcmyGgaps
// SIG // ZGFwOi8vL0NOPWFtZXJvb3QsQ049QU1FUm9vdCxDTj1D
// SIG // RFAsQ049UHVibGljJTIwS2V5JTIwU2VydmljZXMsQ049
// SIG // U2VydmljZXMsQ049Q29uZmlndXJhdGlvbixEQz1BTUUs
// SIG // REM9R0JMP2NlcnRpZmljYXRlUmV2b2NhdGlvbkxpc3Q/
// SIG // YmFzZT9vYmplY3RDbGFzcz1jUkxEaXN0cmlidXRpb25Q
// SIG // b2ludDCCAasGCCsGAQUFBwEBBIIBnTCCAZkwRwYIKwYB
// SIG // BQUHMAKGO2h0dHA6Ly9jcmwubWljcm9zb2Z0LmNvbS9w
// SIG // a2lpbmZyYS9jZXJ0cy9BTUVSb290X2FtZXJvb3QuY3J0
// SIG // MDcGCCsGAQUFBzAChitodHRwOi8vY3JsMi5hbWUuZ2Js
// SIG // L2FpYS9BTUVSb290X2FtZXJvb3QuY3J0MDcGCCsGAQUF
// SIG // BzAChitodHRwOi8vY3JsMy5hbWUuZ2JsL2FpYS9BTUVS
// SIG // b290X2FtZXJvb3QuY3J0MDcGCCsGAQUFBzAChitodHRw
// SIG // Oi8vY3JsMS5hbWUuZ2JsL2FpYS9BTUVSb290X2FtZXJv
// SIG // b3QuY3J0MIGiBggrBgEFBQcwAoaBlWxkYXA6Ly8vQ049
// SIG // YW1lcm9vdCxDTj1BSUEsQ049UHVibGljJTIwS2V5JTIw
// SIG // U2VydmljZXMsQ049U2VydmljZXMsQ049Q29uZmlndXJh
// SIG // dGlvbixEQz1BTUUsREM9R0JMP2NBQ2VydGlmaWNhdGU/
// SIG // YmFzZT9vYmplY3RDbGFzcz1jZXJ0aWZpY2F0aW9uQXV0
// SIG // aG9yaXR5MA0GCSqGSIb3DQEBCwUAA4ICAQBQECO3Tw/o
// SIG // 317Rrd7yadqcswPx1LvIYymkaTN6KcmuRt6HKa0Xe73U
// SIG // x2/AQ30TfgA9GBJngweRykKBusRzyOU17iIubJvy3gA2
// SIG // 1dwtqtB0DsoEv1U/ptVu2v++doTCJ/i+GbssVXkgaX8H
// SIG // +6EOGEmT4evp4GbwR4HwWlc+Dvf8HH8PdUA2Z04CvcwI
// SIG // fckSipbNm84jxJ8XjmTFTWscldL9edj2NsY6iGnyJFIy
// SIG // ur2PS7VRYyV3p1VAJp91gj1jRQtWEyCB8P5g9nE3z8u0
// SIG // ANaU/hjwEQCrdGyravWgnf2JtG+bT26YAokbc8m+32zU
// SIG // tXRO+NK3tAjhOu2FdsG3qNrF4sc7y37R/C+7Pcb/cFfh
// SIG // ttqsirepZii4xStcjMODYuXzGm3IJs0b0owHG6oKd7ZO
// SIG // GvHpmmh9K8/DLriD/sq8bURD10qi/wuW8zM7IpLg1vcR
// SIG // 9dIK2mc0pj44pc6UX0XbttP/VEJgu3lT2eI9VjWtaKjx
// SIG // 38xE9woSMyekPRtzTwgfuysF9DkJisr+yA4po/FPxpbB
// SIG // w9c/hBf32DH/GFxteS2pmjgKIbMP8sDukmEq3lVvuWNJ
// SIG // sybrZwQvQpvaM49fv+JKpLK5YWYEfwksYRR9wU8Hh/ID
// SIG // 9hRCEkbUoQ2W7mMpsp2Nbp/kcn4ivfolUy3Q9Yf0scsQ
// SIG // 6WTLYpm+AoCUJTGCGWEwghldAgEBMFgwQTETMBEGCgmS
// SIG // JomT8ixkARkWA0dCTDETMBEGCgmSJomT8ixkARkWA0FN
// SIG // RTEVMBMGA1UEAxMMQU1FIENTIENBIDAxAhM2AAABqFMr
// SIG // 1lCrrLlTAAIAAAGoMA0GCWCGSAFlAwQCAQUAoIGuMBkG
// SIG // CSqGSIb3DQEJAzEMBgorBgEEAYI3AgEEMBwGCisGAQQB
// SIG // gjcCAQsxDjAMBgorBgEEAYI3AgEVMC8GCSqGSIb3DQEJ
// SIG // BDEiBCBV0Dhhtfo0TkDtyKfR6QFOGidHffJUkINPWmnO
// SIG // Xr+2YjBCBgorBgEEAYI3AgEMMTQwMqAUgBIATQBpAGMA
// SIG // cgBvAHMAbwBmAHShGoAYaHR0cDovL3d3dy5taWNyb3Nv
// SIG // ZnQuY29tMA0GCSqGSIb3DQEBAQUABIIBAB8FfDz5dqQy
// SIG // t9oqLe4TYqJx0aaAyUNphkg/f7cTHbadNd5dNMQSWIxh
// SIG // +r92ciQA8+4AJOQipEMcogYXskL0TpOdSeaCssjW4Ier
// SIG // 1xjImkfsPrZfhsd+hYcLGbUAccPe5/AA59+OLuMqpcyx
// SIG // EJD/TTCnip53f18aiszxUUIpux4LcBpzH4Pnl/LSlUH9
// SIG // a8meZDfghtJhUzIVysgN8IJB/Ml/6FJAcj35knbFsWC0
// SIG // Fk3mZS0dP/9WuheHgD690TW54RTzvhc+3fIFQy+a38qb
// SIG // PqyiFhfSdphvKVLFLeEbBUquRTC/IeVUC53gnbepD/1S
// SIG // YlIIoqP5hCGJlKi2pfE3YW2hghcpMIIXJQYKKwYBBAGC
// SIG // NwMDATGCFxUwghcRBgkqhkiG9w0BBwKgghcCMIIW/gIB
// SIG // AzEPMA0GCWCGSAFlAwQCAQUAMIIBWQYLKoZIhvcNAQkQ
// SIG // AQSgggFIBIIBRDCCAUACAQEGCisGAQQBhFkKAwEwMTAN
// SIG // BglghkgBZQMEAgEFAAQgv8M6oE5px8xVRDowVGTfIB6P
// SIG // QBkwdJfTCaFc6ouX74ECBmQa7ot+9RgTMjAyMzA0MTkw
// SIG // OTMxMDcuMTg3WjAEgAIB9KCB2KSB1TCB0jELMAkGA1UE
// SIG // BhMCVVMxEzARBgNVBAgTCldhc2hpbmd0b24xEDAOBgNV
// SIG // BAcTB1JlZG1vbmQxHjAcBgNVBAoTFU1pY3Jvc29mdCBD
// SIG // b3Jwb3JhdGlvbjEtMCsGA1UECxMkTWljcm9zb2Z0IEly
// SIG // ZWxhbmQgT3BlcmF0aW9ucyBMaW1pdGVkMSYwJAYDVQQL
// SIG // Ex1UaGFsZXMgVFNTIEVTTjoyQUQ0LTRCOTItRkEwMTEl
// SIG // MCMGA1UEAxMcTWljcm9zb2Z0IFRpbWUtU3RhbXAgU2Vy
// SIG // dmljZaCCEXgwggcnMIIFD6ADAgECAhMzAAABscqQQ+4L
// SIG // 8AOrAAEAAAGxMA0GCSqGSIb3DQEBCwUAMHwxCzAJBgNV
// SIG // BAYTAlVTMRMwEQYDVQQIEwpXYXNoaW5ndG9uMRAwDgYD
// SIG // VQQHEwdSZWRtb25kMR4wHAYDVQQKExVNaWNyb3NvZnQg
// SIG // Q29ycG9yYXRpb24xJjAkBgNVBAMTHU1pY3Jvc29mdCBU
// SIG // aW1lLVN0YW1wIFBDQSAyMDEwMB4XDTIyMDkyMDIwMjE1
// SIG // OVoXDTIzMTIxNDIwMjE1OVowgdIxCzAJBgNVBAYTAlVT
// SIG // MRMwEQYDVQQIEwpXYXNoaW5ndG9uMRAwDgYDVQQHEwdS
// SIG // ZWRtb25kMR4wHAYDVQQKExVNaWNyb3NvZnQgQ29ycG9y
// SIG // YXRpb24xLTArBgNVBAsTJE1pY3Jvc29mdCBJcmVsYW5k
// SIG // IE9wZXJhdGlvbnMgTGltaXRlZDEmMCQGA1UECxMdVGhh
// SIG // bGVzIFRTUyBFU046MkFENC00QjkyLUZBMDExJTAjBgNV
// SIG // BAMTHE1pY3Jvc29mdCBUaW1lLVN0YW1wIFNlcnZpY2Uw
// SIG // ggIiMA0GCSqGSIb3DQEBAQUAA4ICDwAwggIKAoICAQCG
// SIG // oqs+1ewbx+yDjDxHgzNlMAqTPC8QFD3ie1L7vatEYgwX
// SIG // QYLIQv0g63t/2CQahqZ9u2u11jjL4ogVHzDX3+dTcSha
// SIG // El+thqat+mC0WZNoTdcIoKwjuues+aVU4yad0PI3WACV
// SIG // 967iXmt3HH04MQIE91L/7D+MNPsmQGGtiWWpVdzAYCBY
// SIG // t1cChQOApUHK/leEqRs6s/H2qmm5mMqbid+WZ/Bv9tNa
// SIG // QDdowxDru0GgwtKxsg3cEk1Zl3BzOOhBVejdhevZ8H49
// SIG // g2Ye+IJwNQwezRXGZ/uL9ZKkFp+wMwSfpZjsbyq1EZVf
// SIG // 7tfTMNWD/s1UMsyp+f+K/77mEkY/7YWa/hZmQFLUwGnC
// SIG // 86LgRDbmkgbjmNZN99HjKfJ53UjVLFI4/55+4HHRas3U
// SIG // DbnSW/l8ZkcIvS8IwNP/D5TrCk2fF8OhBFj1S3zaI0rl
// SIG // qWTE2jM8/8M0j6eSdNpKWJpHZedJcMhkSzuV+4liDSpq
// SIG // F8knUJkXYhjE5L0UrVysSKBJvxCcQmiPpOEt/gVilgtO
// SIG // xFeU91Bu8GxW+C374G22ijOfB8rQMow5zvXxItL66fCR
// SIG // U7RoXbcIRBJK2jLRlbfgr5xtGZR+Jr6T0T7iW6hOdPXu
// SIG // gqph8M07lGTxTBVryZ+Hz79Hd9lrPY79mGJhP9FkdX1C
// SIG // 7Pk8caVoJ9c9DwDrMUmUTwIDAQABo4IBSTCCAUUwHQYD
// SIG // VR0OBBYEFPSbZ5HvDa2EivXxZ6FRNKa9DjmTMB8GA1Ud
// SIG // IwQYMBaAFJ+nFV0AXmJdg/Tl0mWnG1M1GelyMF8GA1Ud
// SIG // HwRYMFYwVKBSoFCGTmh0dHA6Ly93d3cubWljcm9zb2Z0
// SIG // LmNvbS9wa2lvcHMvY3JsL01pY3Jvc29mdCUyMFRpbWUt
// SIG // U3RhbXAlMjBQQ0ElMjAyMDEwKDEpLmNybDBsBggrBgEF
// SIG // BQcBAQRgMF4wXAYIKwYBBQUHMAKGUGh0dHA6Ly93d3cu
// SIG // bWljcm9zb2Z0LmNvbS9wa2lvcHMvY2VydHMvTWljcm9z
// SIG // b2Z0JTIwVGltZS1TdGFtcCUyMFBDQSUyMDIwMTAoMSku
// SIG // Y3J0MAwGA1UdEwEB/wQCMAAwFgYDVR0lAQH/BAwwCgYI
// SIG // KwYBBQUHAwgwDgYDVR0PAQH/BAQDAgeAMA0GCSqGSIb3
// SIG // DQEBCwUAA4ICAQDY5zeSaqXlUoSK0CGgEJzVTr9XAxJg
// SIG // pA+qELn1/TRjl9vCcP4HZBrTCcmoANJVW7psEJWuSz4Q
// SIG // ZuS4yFFv+WmIc0pWe5cXg8pMOe8KdgKqDACZu213F7Sb
// SIG // fx8mkZTd+YQIQVfg5hpwSEXBOQtm0hRWN2rA+dClEgj5
// SIG // ipf9DRWnT3qDam4+WVJ2vFQHzEg7HcXssY7PK//Vaasv
// SIG // JYCFQaka17Rbep9fhhaSftgIz7KXzzu2PmP6M7+XUxGL
// SIG // puXgyw3Q9bYUJh5FvLNAQQ2yDk93fnVnTxE5H+dHzP5w
// SIG // C5DBHb2KNoMoiazkhtGvWdkv+pmyQVK4K5ID6dh4y5Mn
// SIG // EeDYcJeu3oQIVsSRig9oEZPPE9iily4kRwKGE2VaR24J
// SIG // GC7KQSybPQu+2ZLsV7ryDhmiHexCQgTlUTCcoLcfBV6a
// SIG // Ert41hHWrtFgTF8YVQMxB07u1Cltw8PihoFu0UZYa7ef
// SIG // PUivJaz0rzzOjz56hBX+j1LE1TtGzpMypwt0zoLouCYZ
// SIG // VpYooLRLYNUpTzMXHTLnPbmHVkntf9mFpq/Wa1dUbr6U
// SIG // kiryS0mA5Tn+mia6Z1+2CizEaMinc05HL18NSWX4pCXh
// SIG // iY30bNnE9iSG4jRBiuIubK0G1Qr4Ar3WFRFWV1VtSM/y
// SIG // ySyvV2yJDDI5hAiRLGtO6GnSnDuHnfb2OmGARjCCB3Ew
// SIG // ggVZoAMCAQICEzMAAAAVxedrngKbSZkAAAAAABUwDQYJ
// SIG // KoZIhvcNAQELBQAwgYgxCzAJBgNVBAYTAlVTMRMwEQYD
// SIG // VQQIEwpXYXNoaW5ndG9uMRAwDgYDVQQHEwdSZWRtb25k
// SIG // MR4wHAYDVQQKExVNaWNyb3NvZnQgQ29ycG9yYXRpb24x
// SIG // MjAwBgNVBAMTKU1pY3Jvc29mdCBSb290IENlcnRpZmlj
// SIG // YXRlIEF1dGhvcml0eSAyMDEwMB4XDTIxMDkzMDE4MjIy
// SIG // NVoXDTMwMDkzMDE4MzIyNVowfDELMAkGA1UEBhMCVVMx
// SIG // EzARBgNVBAgTCldhc2hpbmd0b24xEDAOBgNVBAcTB1Jl
// SIG // ZG1vbmQxHjAcBgNVBAoTFU1pY3Jvc29mdCBDb3Jwb3Jh
// SIG // dGlvbjEmMCQGA1UEAxMdTWljcm9zb2Z0IFRpbWUtU3Rh
// SIG // bXAgUENBIDIwMTAwggIiMA0GCSqGSIb3DQEBAQUAA4IC
// SIG // DwAwggIKAoICAQDk4aZM57RyIQt5osvXJHm9DtWC0/3u
// SIG // nAcH0qlsTnXIyjVX9gF/bErg4r25PhdgM/9cT8dm95VT
// SIG // cVrifkpa/rg2Z4VGIwy1jRPPdzLAEBjoYH1qUoNEt6aO
// SIG // RmsHFPPFdvWGUNzBRMhxXFExN6AKOG6N7dcP2CZTfDlh
// SIG // AnrEqv1yaa8dq6z2Nr41JmTamDu6GnszrYBbfowQHJ1S
// SIG // /rboYiXcag/PXfT+jlPP1uyFVk3v3byNpOORj7I5LFGc
// SIG // 6XBpDco2LXCOMcg1KL3jtIckw+DJj361VI/c+gVVmG1o
// SIG // O5pGve2krnopN6zL64NF50ZuyjLVwIYwXE8s4mKyzbni
// SIG // jYjklqwBSru+cakXW2dg3viSkR4dPf0gz3N9QZpGdc3E
// SIG // XzTdEonW/aUgfX782Z5F37ZyL9t9X4C626p+Nuw2TPYr
// SIG // bqgSUei/BQOj0XOmTTd0lBw0gg/wEPK3Rxjtp+iZfD9M
// SIG // 269ewvPV2HM9Q07BMzlMjgK8QmguEOqEUUbi0b1qGFph
// SIG // AXPKZ6Je1yh2AuIzGHLXpyDwwvoSCtdjbwzJNmSLW6Cm
// SIG // gyFdXzB0kZSU2LlQ+QuJYfM2BjUYhEfb3BvR/bLUHMVr
// SIG // 9lxSUV0S2yW6r1AFemzFER1y7435UsSFF5PAPBXbGjfH
// SIG // CBUYP3irRbb1Hode2o+eFnJpxq57t7c+auIurQIDAQAB
// SIG // o4IB3TCCAdkwEgYJKwYBBAGCNxUBBAUCAwEAATAjBgkr
// SIG // BgEEAYI3FQIEFgQUKqdS/mTEmr6CkTxGNSnPEP8vBO4w
// SIG // HQYDVR0OBBYEFJ+nFV0AXmJdg/Tl0mWnG1M1GelyMFwG
// SIG // A1UdIARVMFMwUQYMKwYBBAGCN0yDfQEBMEEwPwYIKwYB
// SIG // BQUHAgEWM2h0dHA6Ly93d3cubWljcm9zb2Z0LmNvbS9w
// SIG // a2lvcHMvRG9jcy9SZXBvc2l0b3J5Lmh0bTATBgNVHSUE
// SIG // DDAKBggrBgEFBQcDCDAZBgkrBgEEAYI3FAIEDB4KAFMA
// SIG // dQBiAEMAQTALBgNVHQ8EBAMCAYYwDwYDVR0TAQH/BAUw
// SIG // AwEB/zAfBgNVHSMEGDAWgBTV9lbLj+iiXGJo0T2UkFvX
// SIG // zpoYxDBWBgNVHR8ETzBNMEugSaBHhkVodHRwOi8vY3Js
// SIG // Lm1pY3Jvc29mdC5jb20vcGtpL2NybC9wcm9kdWN0cy9N
// SIG // aWNSb29DZXJBdXRfMjAxMC0wNi0yMy5jcmwwWgYIKwYB
// SIG // BQUHAQEETjBMMEoGCCsGAQUFBzAChj5odHRwOi8vd3d3
// SIG // Lm1pY3Jvc29mdC5jb20vcGtpL2NlcnRzL01pY1Jvb0Nl
// SIG // ckF1dF8yMDEwLTA2LTIzLmNydDANBgkqhkiG9w0BAQsF
// SIG // AAOCAgEAnVV9/Cqt4SwfZwExJFvhnnJL/Klv6lwUtj5O
// SIG // R2R4sQaTlz0xM7U518JxNj/aZGx80HU5bbsPMeTCj/ts
// SIG // 0aGUGCLu6WZnOlNN3Zi6th542DYunKmCVgADsAW+iehp
// SIG // 4LoJ7nvfam++Kctu2D9IdQHZGN5tggz1bSNU5HhTdSRX
// SIG // ud2f8449xvNo32X2pFaq95W2KFUn0CS9QKC/GbYSEhFd
// SIG // PSfgQJY4rPf5KYnDvBewVIVCs/wMnosZiefwC2qBwoEZ
// SIG // QhlSdYo2wh3DYXMuLGt7bj8sCXgU6ZGyqVvfSaN0DLzs
// SIG // kYDSPeZKPmY7T7uG+jIa2Zb0j/aRAfbOxnT99kxybxCr
// SIG // dTDFNLB62FD+CljdQDzHVG2dY3RILLFORy3BFARxv2T5
// SIG // JL5zbcqOCb2zAVdJVGTZc9d/HltEAY5aGZFrDZ+kKNxn
// SIG // GSgkujhLmm77IVRrakURR6nxt67I6IleT53S0Ex2tVdU
// SIG // CbFpAUR+fKFhbHP+CrvsQWY9af3LwUFJfn6Tvsv4O+S3
// SIG // Fb+0zj6lMVGEvL8CwYKiexcdFYmNcP7ntdAoGokLjzba
// SIG // ukz5m/8K6TT4JDVnK+ANuOaMmdbhIurwJ0I9JZTmdHRb
// SIG // atGePu1+oDEzfbzL6Xu/OHBE0ZDxyKs6ijoIYn/ZcGNT
// SIG // TY3ugm2lBRDBcQZqELQdVTNYs6FwZvKhggLUMIICPQIB
// SIG // ATCCAQChgdikgdUwgdIxCzAJBgNVBAYTAlVTMRMwEQYD
// SIG // VQQIEwpXYXNoaW5ndG9uMRAwDgYDVQQHEwdSZWRtb25k
// SIG // MR4wHAYDVQQKExVNaWNyb3NvZnQgQ29ycG9yYXRpb24x
// SIG // LTArBgNVBAsTJE1pY3Jvc29mdCBJcmVsYW5kIE9wZXJh
// SIG // dGlvbnMgTGltaXRlZDEmMCQGA1UECxMdVGhhbGVzIFRT
// SIG // UyBFU046MkFENC00QjkyLUZBMDExJTAjBgNVBAMTHE1p
// SIG // Y3Jvc29mdCBUaW1lLVN0YW1wIFNlcnZpY2WiIwoBATAH
// SIG // BgUrDgMCGgMVAO1ksb6kA2wO78suvU59MD+QRscroIGD
// SIG // MIGApH4wfDELMAkGA1UEBhMCVVMxEzARBgNVBAgTCldh
// SIG // c2hpbmd0b24xEDAOBgNVBAcTB1JlZG1vbmQxHjAcBgNV
// SIG // BAoTFU1pY3Jvc29mdCBDb3Jwb3JhdGlvbjEmMCQGA1UE
// SIG // AxMdTWljcm9zb2Z0IFRpbWUtU3RhbXAgUENBIDIwMTAw
// SIG // DQYJKoZIhvcNAQEFBQACBQDn6QKSMCIYDzIwMjMwNDE4
// SIG // MTk1MDQyWhgPMjAyMzA0MTkxOTUwNDJaMHQwOgYKKwYB
// SIG // BAGEWQoEATEsMCowCgIFAOfpApICAQAwBwIBAAICKLkw
// SIG // BwIBAAICOgUwCgIFAOfqVBICAQAwNgYKKwYBBAGEWQoE
// SIG // AjEoMCYwDAYKKwYBBAGEWQoDAqAKMAgCAQACAwehIKEK
// SIG // MAgCAQACAwGGoDANBgkqhkiG9w0BAQUFAAOBgQCfKvql
// SIG // CK9u+N7JzCvKHyeGiAoEjyNV41XfRatJkAkMsz3XDckF
// SIG // r96U6BR7UM4vl2nQzktP5dGehLN4GvwdhC3dFfT5s022
// SIG // I9KZ2FhzYjkzh9HW+C2Tjerog+iVsqF2lUMmD+NLEbcx
// SIG // y3i6bZSvsI+P95fTLXJQiqYba+P8yYfbojGCBA0wggQJ
// SIG // AgEBMIGTMHwxCzAJBgNVBAYTAlVTMRMwEQYDVQQIEwpX
// SIG // YXNoaW5ndG9uMRAwDgYDVQQHEwdSZWRtb25kMR4wHAYD
// SIG // VQQKExVNaWNyb3NvZnQgQ29ycG9yYXRpb24xJjAkBgNV
// SIG // BAMTHU1pY3Jvc29mdCBUaW1lLVN0YW1wIFBDQSAyMDEw
// SIG // AhMzAAABscqQQ+4L8AOrAAEAAAGxMA0GCWCGSAFlAwQC
// SIG // AQUAoIIBSjAaBgkqhkiG9w0BCQMxDQYLKoZIhvcNAQkQ
// SIG // AQQwLwYJKoZIhvcNAQkEMSIEIDsFZ9jUii/A9YGeqKSQ
// SIG // grveMsxzyYMV7yTNMh/TczfHMIH6BgsqhkiG9w0BCRAC
// SIG // LzGB6jCB5zCB5DCBvQQgg+0NixRb36ng6MvYKbt+benW
// SIG // Hq6wztHDE5TiKJs0z2wwgZgwgYCkfjB8MQswCQYDVQQG
// SIG // EwJVUzETMBEGA1UECBMKV2FzaGluZ3RvbjEQMA4GA1UE
// SIG // BxMHUmVkbW9uZDEeMBwGA1UEChMVTWljcm9zb2Z0IENv
// SIG // cnBvcmF0aW9uMSYwJAYDVQQDEx1NaWNyb3NvZnQgVGlt
// SIG // ZS1TdGFtcCBQQ0EgMjAxMAITMwAAAbHKkEPuC/ADqwAB
// SIG // AAABsTAiBCDC6WTFT+ptAw1HVkJmEXU5x863yFd/LUvm
// SIG // RbBqYvtkCDANBgkqhkiG9w0BAQsFAASCAgBJzkCUTj11
// SIG // UzPhMzwnKQjatmxn+0sbKvznREQ9pzISTTMPGooRa4yP
// SIG // GHTlulNuT0txqGMF3vIC2xIlMuh0QdsFJHXqgQHRI+i9
// SIG // 5jjHPqLre0hieOECsgKErM66sWmMNSb4tknOGwTZpZdY
// SIG // lWx59ABCYUShYb3jLd47cYPBFqdI2pQuoZ/l43pvxKzT
// SIG // oUhoBihb5T8XNBN9oA4t13djye7WUPAD2HpL+oS/8zUH
// SIG // E7/u/Q9Tzu7It4elJ1vRfjUGr4KUisbceYyTF6npQwt6
// SIG // Asi1tErQQef12y8cdvDKwRjrlWZBpLNVgSUW9sES3zSO
// SIG // SgSGfh0QcaauOhbKjM9iz5h0ledOVrwfQ/wo4RS1XPr0
// SIG // s91E8VLQEDCaewdko4y6tdylymtQ2NzaoqjPupKhHn/2
// SIG // wTdV60Q6LD1A6tgx4AAIRDaxTK0JwvYk5cFMCmMXPL7i
// SIG // Vb5QRW6JB8adyzkKqBudGjSOI3TXl/0S+g3bXgmTnyu6
// SIG // WpwFDgsx0PnM/Tf8+Fq0fkTwJzi0/c1Sl9zwmEEyAap9
// SIG // tt3IjiAN7eTO62rzyM7e8sWc/SqgI28pKZ43G5IuTj58
// SIG // VlVBamlXRaSpJuQL67g/plhlRh7KEEY6b+1dw+RbGL6K
// SIG // p9xQzJtyUPyghwqxsTF3k4pQjKBUz4pVikhJN4fc/WYa
// SIG // vGirK9YD9b7Udg==
// SIG // End signature block